const wishlistEmptyIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8v-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5v3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20c0 0-.1-.1-.1-.1c0 0 0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5v3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2v-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"/></svg>'
    , wishlistFillIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"/></svg>'
    , wishlistPopupCloseIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M9.00006 7.00007L16 0L18 2L11 9.00006L18 16L16 18L9.00006 11L2 18L0 16L7.00007 9.00006L0 2L2 0L9.00006 7.00007Z" fill="#161616"/></svg>'
    , wishlistDeleteIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"><path d="M1871 5109 c-128 -25 -257 -125 -311 -241 -37 -79 -50 -146 -50 -259 l0 -89 -389 0 c-222 0 -411 -4 -442 -10 -187 -36 -330 -184 -361 -376 -30 -181 66 -371 231 -458 l69 -36 6 -58 c4 -31 65 -763 136 -1627 72 -863 134 -1587 139 -1608 36 -155 177 -295 335 -332 91 -22 2561 -22 2652 0 158 37 299 177 335 332 5 21 67 745 139 1608 71 864 132 1596 136 1627 l6 58 69 36 c165 87 261 277 231 458 -31 192 -174 340 -361 376 -31 6 -220 10 -442 10 l-389 0 0 89 c0 48 -5 112 -10 142 -34 180 -179 325 -359 359 -66 12 -1306 12 -1370 -1z m1359 -309 c60 -31 80 -78 80 -190 l0 -90 -750 0 -750 0 0 90 c0 110 20 159 78 189 36 19 60 20 670 21 615 0 634 -1 672 -20z m1200 -600 c45 -23 80 -80 80 -130 0 -50 -35 -107 -80 -130 -39 -20 -55 -20 -1870 -20 -1815 0 -1831 0 -1870 20 -45 23 -80 80 -80 130 0 48 35 107 78 129 36 20 65 20 1870 21 1818 0 1833 0 1872 -20z m-236 -622 c-2 -24 -63 -747 -134 -1606 -140 -1694 -129 -1598 -193 -1646 l-28 -21 -1279 0 -1279 0 -28 21 c-64 48 -53 -48 -193 1646 -71 859 -132 1582 -134 1606 l-6 42 1640 0 1640 0 -6 -42z"></path><path d="M1587 3299 c-25 -13 -45 -34 -58 -62 l-21 -43 76 -1234 c85 -1381 76 -1299 155 -1340 51 -25 91 -25 142 0 27 14 46 34 60 63 l21 43 -76 1234 c-85 1381 -76 1299 -155 1340 -50 25 -95 25 -144 -1z"></path><path d="M2488 3299 c-23 -12 -46 -35 -58 -59 -20 -39 -20 -57 -20 -1280 0 -1224 0 -1241 20 -1280 23 -45 80 -80 130 -80 50 0 107 35 130 80 20 39 20 56 20 1280 0 1224 0 1241 -20 1280 -37 73 -127 99 -202 59z"></path><path d="M3387 3299 c-77 -41 -68 37 -153 -1339 l-76 -1234 21 -43 c14 -29 33 -49 60 -63 51 -25 91 -25 142 0 79 41 70 -41 155 1340 l76 1234 -21 43 c-37 75 -127 103 -204 62z"></path></g></svg>'
    , wishlistLikeEmptyIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 478.2 478.2" style="" xml:space="preserve" class=""><g><path d="M457.575 325.1c9.8-12.5 14.5-25.9 13.9-39.7-.6-15.2-7.4-27.1-13-34.4 6.5-16.2 9-41.7-12.7-61.5-15.9-14.5-42.9-21-80.3-19.2-26.3 1.2-48.3 6.1-49.2 6.3h-.1c-5 .9-10.3 2-15.7 3.2-.4-6.4.7-22.3 12.5-58.1 14-42.6 13.2-75.2-2.6-97-16.6-22.9-43.1-24.7-50.9-24.7-7.5 0-14.4 3.1-19.3 8.8-11.1 12.9-9.8 36.7-8.4 47.7-13.2 35.4-50.2 122.2-81.5 146.3-.6.4-1.1.9-1.6 1.4-9.2 9.7-15.4 20.2-19.6 29.4-5.9-3.2-12.6-5-19.8-5h-61c-23 0-41.6 18.7-41.6 41.6v162.5c0 23 18.7 41.6 41.6 41.6h61c8.9 0 17.2-2.8 24-7.6l23.5 2.8c3.6.5 67.6 8.6 133.3 7.3 11.9.9 23.1 1.4 33.5 1.4 17.9 0 33.5-1.4 46.5-4.2 30.6-6.5 51.5-19.5 62.1-38.6 8.1-14.6 8.1-29.1 6.8-38.3 19.9-18 23.4-37.9 22.7-51.9-.4-8.1-2.2-15-4.1-20.1zm-409.3 122.2c-8.1 0-14.6-6.6-14.6-14.6V270.1c0-8.1 6.6-14.6 14.6-14.6h61c8.1 0 14.6 6.6 14.6 14.6v162.5c0 8.1-6.6 14.6-14.6 14.6h-61v.1zm383.7-133.9c-4.2 4.4-5 11.1-1.8 16.3 0 .1 4.1 7.1 4.6 16.7.7 13.1-5.6 24.7-18.8 34.6-4.7 3.6-6.6 9.8-4.6 15.4 0 .1 4.3 13.3-2.7 25.8-6.7 12-21.6 20.6-44.2 25.4-18.1 3.9-42.7 4.6-72.9 2.2h-1.4c-64.3 1.4-129.3-7-130-7.1h-.1l-10.1-1.2c.6-2.8.9-5.8.9-8.8V270.1c0-4.3-.7-8.5-1.9-12.4 1.8-6.7 6.8-21.6 18.6-34.3 44.9-35.6 88.8-155.7 90.7-160.9.8-2.1 1-4.4.6-6.7-1.7-11.2-1.1-24.9 1.3-29 5.3.1 19.6 1.6 28.2 13.5 10.2 14.1 9.8 39.3-1.2 72.7-16.8 50.9-18.2 77.7-4.9 89.5 6.6 5.9 15.4 6.2 21.8 3.9 6.1-1.4 11.9-2.6 17.4-3.5.4-.1.9-.2 1.3-.3 30.7-6.7 85.7-10.8 104.8 6.6 16.2 14.8 4.7 34.4 3.4 36.5-3.7 5.6-2.6 12.9 2.4 17.4.1.1 10.6 10 11.1 23.3.4 8.9-3.8 18-12.5 27z" fill="#000000" opacity="1" data-original="#000000"></path></g></svg>'
    , wishlistLikeFillIcon = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 511.999 511.999" style="" xml:space="preserve" class=""><g><path d="M15.34 224.948c-8.365 0-15.146 6.782-15.146 15.146v222.458c0 8.365 6.782 15.146 15.146 15.146h91.253v-252.75H15.34zM511.805 308.587c0-19.227-10.331-36.087-25.733-45.321a52.504 52.504 0 0 0 9.362-29.985c0-29.113-23.686-52.799-52.799-52.799H331.177c3.416-15.48 8.088-38.709 11.341-63.026 8.466-63.281 2.68-98.376-18.207-110.445-13.022-7.523-27.062-9.049-39.534-4.301-9.635 3.67-22.647 12.693-30.062 34.838l-29.294 76.701c-14.851 36.677-60.33 75.182-88.535 96.473V484.4C189.16 502.716 243.708 512 299.358 512h121.446c29.113 0 52.799-23.686 52.799-52.799a52.481 52.481 0 0 0-7.93-27.804c17.601-8.572 29.759-26.646 29.759-47.503a52.504 52.504 0 0 0-9.362-29.985c15.404-9.234 25.735-26.095 25.735-45.322z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg>'
    , techno_setCookie = (cname, cValue, exDays) => {
        var d = new Date;
        d.setTime(d.getTime() + exDays * 24 * 60 * 60 * 1e3);
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cValue + ";" + expires + ";path=/"
    }
    , techno_getCookie = cname => {
        for (var name = cname + "=", ca = document.cookie.split(";"), i = 0; i < ca.length; i++) {
            for (var c = ca[i]; c.charAt(0) == " ";)
                c = c.substring(1);
            if (c.indexOf(name) == 0)
                return c.substring(name.length, c.length)
        }
        return ""
    }
    ;
(function patchWishlistQuickAddModalSection() {
    if (window.__ttWishlistQuickAddModalPatch || typeof ModalDialog === "undefined")
        return;
    window.__ttWishlistQuickAddModalPatch = !0;
    ModalDialog.prototype.connectedCallback = function() {
        if (this.moved)
            return;
        this.moved = !0;
        const section = this.closest(".shopify-section");
        this.dataset.section = section?.id?.replace("shopify-section-", "") || window.wishlistCardSectionId || "wishlist-product-card";
        document.body.appendChild(this)
    }
}
)();
//enable guest wishlist in customer data
document.addEventListener('DOMContentLoaded', () => {
    // Check if the `customerExist` flag is present in the global window object
    if (window?.customerExist) {
        // Retrieve guest category data and wishlist items from cookies
        let guestUserId = techno_getCookie("techno_guest_user_id");
        let guestWishlistItem = techno_getCookie("wishlist");

        // Proceed only if guest data exists in cookies
        if (guestUserId) {
            const handleGuestMode = async () => {
                try {
                    // Parse the retrieved cookie data to JSON format
                    // guestData = JSON.parse(guestData);
                    // guestWishlistItem = JSON.parse(guestWishlistItem);

                    // Call API to update guest category with wishlist items
                    await moveGuestToCustomerOnLogin(guestUserId);

                    // Helper function to delete cookies by name
                    const deleteCookie = (name, path = '/', expires = 'Thu, 01 Jan 1970 00:00:00 UTC') => {
                        document.cookie = `${name}=; path=${path}; expires=${expires};`;
                    };

                    // Clear cookies after successful API call
                    deleteCookie("wishlist_category"); // Delete guest category data
                    deleteCookie("wishlist"); // Delete guest wishlist items
                    deleteCookie("techno_guest_user_id"); // Delete guest wishlist items
                } catch (error) {
                    // Log errors for debugging purposes
                    console.error("Error in handling guest mode:", error);
                }
            };

            // Invoke the guest mode handler
            handleGuestMode();
        }
    }

    // button_setting arrives as a raw JSON string from Liquid/metafields â€”
    // parse it before comparing launch_btn_type.
    try {
        let btnSetting = window.wishlistMetafields?.button_setting;
        if (typeof btnSetting === 'string') btnSetting = JSON.parse(btnSetting);
        if (btnSetting?.launch_btn_type === 'header_icon') {
            injectHeaderIcon();
        }
    } catch (e) {
        console.warn('[Super Wishlist] Could not parse button_setting:', e);
    }
})
    , getMainButtonClass = buttonSty => {
        let btnClass = "";
        return buttonSty && (buttonSty == 1 ? btnClass = "tt-icon-border" : buttonSty == 2 ? btnClass = "tt-border" : buttonSty == 3 ? btnClass = "tt-icon-fill" : buttonSty == 4 ? btnClass = "tt-fill" : buttonSty == 5 ? btnClass = "tt-icon-text" : buttonSty == 6 ? btnClass = "tt-text" : buttonSty == 7 && (btnClass = "tt-only-icon")),
            btnClass
    }
    , techno_formatMoney = (t, e = window.money_format) => {
        function o(t2, e2) {
            return t2 === void 0 ? e2 : t2
        }
        function i(t2, e2, i2, r2) {
            if (e2 = o(e2, 2),
                i2 = o(i2, ","),
                r2 = o(r2, "."),
                isNaN(t2) || t2 == null)
                return 0;
            t2 = (t2 / 100).toFixed(e2);
            var n2 = t2.split(".");
            return n2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i2) + (n2[1] ? r2 + n2[1] : "")
        }
        typeof t == "string" && (t = t.replace(".", ""));
        var r = ""
            , n = /\{\{\s*(\w+)\s*\}\}/
            , a = e || "\u20B9 {{amount}}";
        switch (a.match(n)[1]) {
            case "amount":
                r = i(t, 2);
                break;
            case "amount_no_decimals":
                r = i(t, 0);
                break;
            case "amount_with_comma_separator":
                r = i(t, 2, ".", ",");
                break;
            case "amount_with_space_separator":
                r = i(t, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                r = i(t, 2, " ", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                r = i(t, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                r = i(t, 0, " ");
                break;
            case "amount_with_apostrophe_separator":
                r = i(t, 2, "'", ".")
        }
        return a.replace(n, r)
    }
/**
 * Enhanced toast notification system
 */
const escapeWishlistAttr = value => String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const wishlistImageAlt = async (handle, fallback = "") => {
    try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}?view=rv-meta`);
        if (!response.ok)
            return fallback;
        const meta = await response.json();
        const subtitle = meta && meta.subtitle != null ? String(meta.subtitle).trim() : "";
        const imageAlt = meta && meta.image_alt != null ? String(meta.image_alt).trim() : "";
        return subtitle || imageAlt || fallback
    } catch (error) {
        return fallback
    }
};

const showToastMsg = async (handle, isLocal = false, listName = '') => {
    try {
        const notificationSetting = window.wishlistMetafields.notification_setting;
        const notificationEnable = window.wishlistMetafields.show_notification_popup;

        if (notificationEnable == 0) return false;

        const toastDuration = notificationSetting.duration;
        const className = notificationSetting.notificationPlacement;
        const brandEnable = notificationSetting.enableBranding;
        const brandText = notificationSetting.brandText;

        // Fetch product data
        const [productResponse, metaAlt] = await Promise.all([
            fetch(`/products/${handle}.js`),
            wishlistImageAlt(handle, "")
        ]);
        if (!productResponse.ok) {
            console.error('Failed to fetch product data for toast');
            return false;
        }

        const product = await productResponse.json();
        const content = {
            src: product.featured_image,
            title: product.title,
            alt: escapeWishlistAttr(metaAlt),
            listName: listName
        };

        // Create toast element
        const toastElement = document.createElement('DIV');
        toastElement.className = `wishlist-toast-msg-wrap tt-position ${className}`;

        // Build brand HTML
        const brandHtml = brandEnable == 1
            ? `<p class="wishlist-branding-wrap wishlist-p-tag">${brandText}</p>`
            : '';

        // Build message
        let message = `<strong>${content.title}</strong> has been added${isLocal ? '' : ' to ' + content.listName} successfully`;

        if (isLocal && window.wishlistMsgWithoutCategory) {
            message = window.wishlistMsgWithoutCategory.replace('##', content.title);
        } else if (!isLocal && window.wishlistMsgWithCategory) {
            message = window.wishlistMsgWithCategory
                .replace('##', content.title)
                .replace('$$', content.listName || '');
        }

        // Set toast content
        toastElement.innerHTML = `
      <div class="wishlist-toast-msg">
        <div class="left-side-img">
          <img src="${content.src}" alt="${content.alt}" loading="lazy" />
        </div>
        <div class="right-side-content">
          <p class="wishlist-product-toast-msg wishlist-p-tag">${message}</p>
          ${brandHtml}
        </div>
      </div>
    `;

        // Add to DOM
        document.body.appendChild(toastElement);

        // Auto-remove toast
        setTimeout(() => {
            const toasts = document.querySelectorAll('.wishlist-toast-msg-wrap');
            toasts.forEach(toast => toast.remove());
        }, Number(toastDuration) * 1000);

        return true;
    } catch (error) {
        console.error('Error showing toast message:', error);
        return false;
    }
};

/**
 * Enhanced popup management
 */
const isTruthySetting = val => val == 1 || val == "1" || val === !0
    , shouldHideShareOption = val => {
        if (val === undefined || val === null || val === "")
            return !1;
        return !isTruthySetting(val)
    }
    , applySharePopupOptions = (sharePopup, shareData) => {
        if (!sharePopup)
            return;
        let optionKeys = ["facebook", "twitter", "whatsapp", "email", "copy_link"]
            , hasConfiguredShareOptions = !!(shareData && optionKeys.some(key => isTruthySetting(shareData[key])))
            , setOption = (selector, value) => {
                let el = sharePopup.querySelector(selector);
                el && el.classList.toggle("tt-hide", !!shareData && hasConfiguredShareOptions && shouldHideShareOption(value))
            }
            ;
        setOption(".tt-fb-share", shareData?.facebook);
        setOption(".tt-twitter-share", shareData?.twitter);
        setOption(".tt-wp-share", shareData?.whatsapp);
        setOption(".tt-email-share", shareData?.email);
        setOption(".tt-share-copy", shareData?.copy_link);
        sharePopup.querySelector(".tt-share-wishlist-main")?.classList.remove("tt-hide");
        sharePopup.querySelector(".tt-social-share")?.classList.remove("tt-hide")
    }
    , isCategoryEnabled = () => isTruthySetting(window.wishlistMetafields?.category_enable)
    // Real Shopify login only — never treat GUEST-* / leftover cookies as logged-in.
    , restoreShopifyCustomerId = () => {
        if (window.isWishlistSharedPage || isWishlistSharePageUrl())
            return;
        if (window.isShopifyLoggedIn !== !0)
            return;
        const shopifyId = String(window.shopifyCustomerId || "").trim();
        if (!shopifyId || shopifyId.startsWith("GUEST-"))
            return;
        window.customerId = shopifyId;
        window.customerExist = !0;
    }
    , isWishlistSharePageUrl = () => {
        const path = window.location.pathname || "";
        const sharedId = String(new URLSearchParams(window.location.search).get("q") || "").trim();
        return /wishlist-share/i.test(path) && !!sharedId
    }
    , getWishlistShareCustomerId = () => {
        if (!isWishlistSharePageUrl())
            return "";
        return String(new URLSearchParams(window.location.search).get("q") || "").trim()
    }
    , applyWishlistSharePageSession = () => {
        const sharedCustomerId = getWishlistShareCustomerId();
        if (!sharedCustomerId)
            return !1;
        window.isWishlistSharedPage = !0;
        window.customerExist = !0;
        window.customerId = sharedCustomerId;
        return !0
    }
    , isWishlistAppProxyPage = () => {
        return /\/apps\/wishlist\//i.test(window.location.pathname || "")
    }
    , getWishlistPageRoot = () => {
        if (!isWishlistAppProxyPage())
            return null;
        if (window.isWishlistSharedPage || isWishlistSharePageUrl())
            return document.querySelector(window.wishlistSharedPageSelector);
        return document.querySelector(window.wishlistPageSelector)
    }
    , mountWishlistPageShell = () => {
        if (!isWishlistAppProxyPage())
            return null;
        let pageRoot = getWishlistPageRoot();
        if (!pageRoot) {
            const mainContent = document.querySelector("#MainContent");
            if (!mainContent)
                return null;
            pageRoot = document.createElement("div");
            pageRoot.className = window.isWishlistSharedPage || isWishlistSharePageUrl() ? "tt-wishlist-share-page-main" : "tt-wishlist-landing-page-main";
            mainContent.prepend(pageRoot)
        }
        let mainEle = document.querySelector(".tt-wishlist-details-main");
        if (!mainEle)
            return pageRoot;
        mainEle.hidden = false;
        pageRoot.classList.add("tt-wishlist-landing-active");
        mainEle.classList.add("tt-wishlist-page-layout");
        pageRoot.contains(mainEle) || pageRoot.append(mainEle);
        return pageRoot
    }
    , hideWishlistAppProxyNoise = pageRoot => {
        if (!isWishlistAppProxyPage() || !pageRoot)
            return;
        const mainContent = document.querySelector("#MainContent");
        if (!mainContent)
            return;
        mainContent.querySelectorAll(":scope > *").forEach(node => {
            if (node === pageRoot || node.contains(pageRoot))
                return;
            node.setAttribute("data-tt-wishlist-hidden", "1");
            node.style.display = "none"
        }
        )
    }
    , isLoggedInWishlistCustomer = () => {
        if (window.isWishlistSharedPage)
            return !1;
        if (window.isShopifyLoggedIn !== !0)
            return !1;
        restoreShopifyCustomerId();
        const id = String(window.customerId || window.shopifyCustomerId || "").trim();
        return !!window.customerExist && !!id && !id.startsWith("GUEST-")
    }
    , isGuestWishlistSession = () => {
        // Never treat a real Shopify login as guest (leftover guest cookies must not win).
        if (window.isWishlistSharedPage || isLoggedInWishlistCustomer())
            return !1;
        if (!isTruthySetting(window.wishlistMetafields?.guest_wishlist))
            return !1;
        const guestId = getShareCustomerId();
        return String(guestId).startsWith("GUEST-") || !!techno_getCookie("techno_guest_user_id")
    }
    , getGuestCustomerId = () => getShareCustomerId()
    , getShareCustomerId = () => {
        if (window.isWishlistSharedPage || isWishlistSharePageUrl()) {
            const sharedId = getWishlistShareCustomerId();
            if (sharedId)
                return sharedId
        }
        // Logged-in Shopify id always wins over guest cookie residue.
        if (window.isShopifyLoggedIn === !0) {
            const shopifyId = String(window.shopifyCustomerId || window.customerId || "").trim();
            if (shopifyId && !shopifyId.startsWith("GUEST-"))
                return shopifyId;
        }
        const id = window.customerId || techno_getCookie("techno_guest_user_id") || "";
        return String(id).trim()
    }
    , isShareWishlistEnabled = () => isTruthySetting(window.wishlistMetafields?.share_wishlist)
    , canShowShareWishlist = () => {
        if (window.isWishlistSharedPage)
            return !1;
        if (!isShareWishlistEnabled() && !isTruthySetting(window.wishlistMetafields?.guest_wishlist))
            return !1;
        if (isLoggedInWishlistCustomer())
            return !!getShareCustomerId();
        return hasLocalWishlistItems()
    }
    , hasLocalWishlistItems = () => {
        try {
            const raw = techno_getCookie("wishlist");
            if (!raw)
                return !1;
            const items = JSON.parse(raw);
            return Array.isArray(items) && items.length > 0
        } catch (error) {
            return !1
        }
    }
    , wishlistPopupOpen = (flag = false) => {
        let module = window.wishlistMetafields.button_setting.wishlist_module
            , popupWrap = document.querySelector(".tt-wishlist-details-popup");
        if (!popupWrap)
            return;
        module == "drawer" && popupWrap.classList.add("drawer"),
            flag ? (popupWrap.classList.remove("active"),
                document.body.classList.remove("tt-overflow-hidden")) : (popupWrap.classList.add("active"),
                    document.body.classList.add("tt-overflow-hidden"),
                    typeof wishlistData != "undefined" && wishlistData.enableShareWishlist())
    }
    , setWishlistAPIData = async () => {
        let module = window.wishlistMetafields.button_setting.wishlist_module
            , category_enable = window.wishlistMetafields.category_enable
            , empty_wishlist = window.wishlistMetafields.language2.empty_wishlist
            , fontSizeMultipler = 1;
        module == "page" && (fontSizeMultipler = .75);
        let mainWrap = document.querySelector(".tt-wishlist-details-main")
            , cartMainWrap = document.querySelector(".tt-wishlist-save-for-later");
        if (!mainWrap)
            return;
        mainWrap.setAttribute("style", `--tt-wishlist-font-multipler:${fontSizeMultipler};`);
        let contentWrap = mainWrap.querySelector(".tt-wishlist-details-content");
        let cartContentWrap = null;
        if (cartMainWrap) {
            cartMainWrap.setAttribute('style', `--tt-wishlist-font-multipler:${fontSizeMultipler};`);
            cartContentWrap = cartMainWrap.querySelector(".tt-wishlist-details-content");

        }
        let tabHeader = ""
            , tabContent = ""
            , count = 0
            , categoriesDetails = await getCategoriesDetailsApi();
        if (window.isWishlistSharedPage && categoriesDetails.status == 200 && categoriesDetails.data && categoriesDetails.data.length > 0) {
            let sharedProducts = [];
            categoriesDetails.data.filter(category => category.category_name !== "Save for later").forEach(category => {
                category.details && category.details.forEach(product => {
                    sharedProducts.push(product)
                }
                )
            }
            );
            count = sharedProducts.length;
            let productList = sharedProducts.map(product => `
                        <div class="tt-product-list" data-id="${product.product_id}" data-handle="${product.handle}">
                        </div>
                    `).join("");
            productList || (productList = `<p style="text-align:center;">
                    ${empty_wishlist}
                </p>`);
            contentWrap && (contentWrap.innerHTML = `
                <div class="tt-tab-content-wrap">
                    <div class="active tab-content-inner-wrap" data-tab="tab0">
                        ${productList}
                    </div>
                </div>
            `);
            wishlistUpdateCount(count);
            updateProductContent();
            return
        }
        if (categoriesDetails.status == 200)
            if (categoriesDetails.data && categoriesDetails.data.length > 0) {
                let saveCategory = {
                    ...categoriesDetails
                }.data.find(item => item.category_name == "Save for later");
                categoriesDetails.data = categoriesDetails.data.filter(category => category.category_name !== "Save for later");
                let newCategory = categoriesDetails.data;
                if (newCategory = newCategory.filter(category => category.category_name !== "Save for later"),
                    !category_enable && window.customerExist && categoriesDetails.data.forEach((category, index) => {
                        index != 0 && (newCategory[0].details = newCategory[0].details.concat(category.details),
                            category.details = [])
                    }
                    ),
                    newCategory.forEach((category, index) => {
                        let categoryRemoveBtn = `
                    <button type="button" class="tt-category-remove" data-cid="${category.category_id}">
                        ${wishlistDeleteIcon}
                    </button>
                `;
                        window.isWishlistSharedPage && (categoryRemoveBtn = ""),
                            tabHeader += `
                    <li class="${index == 0 ? "active" : ""}" data-tab="tab${index}">
                        <button type="button" class="tt-tab-title" data-tab="tab${index}">${category.category_name}</button>
                        ${categoryRemoveBtn}
                    </li>
                `;
                        let productList = "";
                        category.details.forEach(product => {
                            count++,
                                productList += `
                        <div class="tt-product-list" data-id="${product.product_id}" data-handle="${product.handle}">
                        </div>
                    `
                        }
                        ),
                            productList == "" && (productList = `<p style="text-align:center;">
                        ${empty_wishlist}
                    </p>`),
                            tabContent += `
                    <div class="${index == 0 ? "active" : ""} tab-content-inner-wrap" data-tab="tab${index}">
                        ${productList}
                    </div>
                `
                    }
                    ),
                    contentWrap && (contentWrap.innerHTML = `
                <ul class="tt-tab-header-wrap">${tabHeader}</ul>
                <div class="tt-tab-content-wrap">${tabContent}</div>
            `),
                    saveCategory != undefined && saveCategory.details.length > 0) {
                    let saveProductList = "";
                    saveCategory.details.forEach(product => {
                        saveProductList += `
                        <div class="tt-product-list tt-sfl" data-handle="${product.handle}">
                        </div>
                    `
                    }
                    );
                    if (cartContentWrap != null)
                        cartContentWrap.innerHTML = `
                      <div class="tt-wishlist-details-main save_for_later_cat">
                    <ul class="tt-tab-header-wrap">
                    <li class="active">
                            <button type="button" class="tt-tab-title" >Save for later</button>
                        </li>
                    </ul>
                    <div class="tt-tab-content-wrap"><div class="tab-content-inner-wrap active">${saveProductList}</div>
                    </div>
                    </div>
                `
                } else
                    if (cartContentWrap != null)
                        cartContentWrap.innerHTML = "";
                updateProductContent()
            } else
                contentWrap.innerHTML = `
                <p style="text-align:center;">
                    ${empty_wishlist}
                </p>
            `;
        else
            contentWrap.innerHTML = `
            <p style="text-align:center;">
                ${empty_wishlist}
            </p>
        `;
        if (!category_enable && window.customerExist) {
            let tabHeaderEle = document.querySelectorAll(".tt-tab-header-wrap");
            tabHeaderEle && tabHeaderEle.forEach(item => {
                item.closest(".tt-wishlist-save-for-later") || item.classList.add("tt-hide")
            }
            )
        }
        wishlistUpdateCount(count)
    }
    , setWishlistLocalData = async flag => {
        let module = window.wishlistMetafields.button_setting.wishlist_module
            , empty_wishlist = window.wishlistMetafields.language2.empty_wishlist
            , fontSizeMultipler = 1;
        module == "page" && (fontSizeMultipler = .75);
        let count = 0
            , mainWrap = document.querySelector(".tt-wishlist-details-main");
        if (!mainWrap)
            return;
        mainWrap.setAttribute("style", `--tt-wishlist-font-multipler:${fontSizeMultipler};`);
        let contentWrap = mainWrap.querySelector(".tt-wishlist-details-content")
            , tabContent = ""
            , productsData = techno_getCookie("wishlist");
        productsData ? (productsData = JSON.parse(productsData),
            productsData && productsData.length > 0 ? (productsData.forEach((product, index) => {
                count++,
                    tabContent += `
                    <div class="tt-product-list" data-id="${product.p_id || ''}" data-handle="${product.p_handle}">
                    </div>
                `
            }
            ),
                tabContent == "" && (tabContent = `<p style="text-align:center;">
                    ${empty_wishlist}
                </p>`),
                contentWrap.innerHTML = `
                <div class="tt-tab-content-wrap">
                    <div class="active tab-content-inner-wrap" data-tab="tab0">
                        ${tabContent}
                    </div>
                </div>
            `,
                updateProductContent()) : contentWrap.innerHTML = `
                <p style="text-align:center;">
                    ${empty_wishlist}
                </p>
            `) : contentWrap.innerHTML = `
            <p style="text-align:center;">
                ${empty_wishlist}
            </p>
        `,
            flag && (contentWrap.innerHTML = `
            <p style="text-align:center;">
                ${empty_wishlist}
            </p>
        `),
            wishlistUpdateCount(count),
            typeof wishlistData != "undefined" && wishlistData.enableShareWishlist()
    }
    , isWishlistLandingLayout = () => {
        let main = document.querySelector(".tt-wishlist-details-main");
        if (!main)
            return !1;
        let landing = document.querySelector(window.wishlistPageSelector)
            , shared = document.querySelector(window.wishlistSharedPageSelector);
        return !!((landing && landing.contains(main)) || (shared && shared.contains(main)) || main.closest(".tt-wishlist-landing-active"))
    }
    , isWishlistPageContext = () => {
        return isWishlistAppProxyPage() || isWishlistLandingLayout()
    }
    , shouldUseThemeProductCard = () => {
        return (isWishlistLandingLayout() || window.isWishlistSharedPage) && window.wishlistUseThemeProductCard !== false
    }
    , fetchThemeProductCard = async handle => {
        let sectionId = window.wishlistCardSectionId || "wishlist-product-card";
        try {
            let response = await fetch(`/products/${encodeURIComponent(handle)}?section_id=${sectionId}`);
            if (!response.ok)
                return null;
            let doc = new DOMParser().parseFromString(await response.text(), "text/html")
                , card = doc.querySelector("product-component") || doc.querySelector(".product-card-wrapper");
            return card ? card.outerHTML : null
        } catch (error) {
            return null
        }
    }
    , upgradeWishlistThemeCardElements = root => {
        if (!root)
            return;
        root.querySelectorAll("quick-add-modal").forEach(modal => {
            if (!modal.moved) {
                modal.moved = !0;
                modal.dataset.section = modal.dataset.section || window.wishlistCardSectionId || "wishlist-product-card";
                modal.parentElement !== document.body && document.body.appendChild(modal)
            }
            try {
                customElements.upgrade(modal)
            } catch (_) {}
        }
        );
        ["modal-opener", "product-form", "product-info", "slider-component"].forEach(tag => {
            root.querySelectorAll(tag).forEach(el => {
                try {
                    customElements.upgrade(el)
                } catch (_) {}
            }
            )
        }
        )
    }
    , injectWishlistThemeCard = (target, html) => {
        if (!target || !html)
            return null;
        const sectionHost = document.createElement("div");
        sectionHost.className = "shopify-section";
        sectionHost.id = "shopify-section-" + (window.wishlistCardSectionId || "wishlist-product-card");
        sectionHost.style.display = "contents";
        target.appendChild(sectionHost);
        sectionHost.innerHTML = html;
        const cardRoot = sectionHost.querySelector("product-component, .product-card-wrapper");
        cardRoot && target.appendChild(cardRoot);
        sectionHost.remove();
        upgradeWishlistThemeCardElements(target);
        return cardRoot
    }
    , wishlistUpdateCount = count => {
        let countWrap = document.querySelector(".wishlist-total-count");
        count || (count = 0);
        if (count < 1) {
            document.querySelectorAll('.wishlist-total-count').forEach(function (e) {
                e.style.display = "none";
            })
        } else {
            document.querySelectorAll('.wishlist-total-count').forEach(function (e) {
                e.style.display = "flex";
                e.innerHTML = count;
            })
        };
        countWrap && (countWrap.innerHTML = count);
        document.querySelectorAll(".tt-wishlist-saved-count__value").forEach(el => {
            el.textContent = count
        });
        document.querySelectorAll(".tt-wishlist-add-all-btn").forEach(el => {
            el.classList.toggle("tt-hide", !isWishlistLandingLayout() || count < 1)
        })
    }
    , wishlistContent = () => {
        // Shared wishlist page always uses API for the shared customer id.
        if (window.isWishlistSharedPage) {
            setWishlistAPIData();
            return;
        }
        // Logged-in Shopify customers use API (categories + server items).
        if (isLoggedInWishlistCustomer()) {
            setWishlistAPIData();
            return;
        }
        // Guests always render from cookies. Server guest-category sync is best-effort
        // (can fail on plan limits) and must never blank the wishlist UI.
        if (isTruthySetting(window.wishlistMetafields?.guest_wishlist) || isGuestWishlistSession()) {
            setWishlistLocalData();
            return;
        }
        setWishlistLocalData(!0);
    }
    , updateProductContent = (flag = !1, isTrending) => {
        let allProductArr = [];
        document.querySelectorAll(".tt-product-list").forEach(ele => {
            isTrending ? allProductArr.push(ele) : ele.closest(".tt-wishlist-trending-wrap") || allProductArr.push(ele)
        }
        ),
            fetchProductDetails(allProductArr, flag)
    }
    , fetchProductDetails = async (products, flag) => {
        if (products && products.length > 0) {
            let language2 = window.wishlistMetafields.language2
                , atcText = language2.btn_move_to_cart
                , oosText = language2.btn_oos_text
                , atcColor = language2.btn_text_color
                , oosColor = language2.oos_text_color
                , atcColorBg = language2.btn_bg_color
                , oosColorBg = language2.oos_bg_color;

            // Process products in parallel batches for better performance
            const batchSize = 5; // Process 5 products at a time
            const processBatch = async (productBatch) => {
                const promises = productBatch.map(async (currentProduct) => {
                    const pHandle = currentProduct.getAttribute("data-handle");
                    const pid = currentProduct.getAttribute("data-id");

                    currentProduct.setAttribute("style", `--tt-atc-btn-color:${atcColor}; --tt-atc-btn-bg:${atcColorBg}; --tt-oos-btn-color:${oosColor}; --tt-oos-btn-bg:${oosColorBg};`);

                    try {
                        if (shouldUseThemeProductCard()) {
                            let themeCardHtml = await fetchThemeProductCard(pHandle);
                            if (themeCardHtml) {
                                currentProduct.classList.add("tt-product-list--theme-card");
                                injectWishlistThemeCard(currentProduct, themeCardHtml)?.querySelector("product-component")?.dispatchViewEvent?.() || currentProduct.querySelector("product-component")?.dispatchViewEvent?.();
                                return
                            }
                        }

                        const [productResponse, metaAlt] = await Promise.all([
                            fetch(`/products/${pHandle}.js`),
                            wishlistImageAlt(pHandle, "")
                        ]);

                        if (productResponse.status == 200) {
                            const product = await productResponse.json();
                            const imageAlt = escapeWishlistAttr(metaAlt);

                            let variantHtml = '';
                            let defaultVariant = false;
                            let atcButton = true;

                            if (!product.available) {
                                atcButton = false;
                                defaultVariant = true;
                            }

                            if (product.available) {
                                product.variants.forEach((variant, index) => {
                                    if (variant.title == 'Default Title') {
                                        defaultVariant = true;
                                        if (!variant.available) {
                                            atcButton = false;
                                        }
                                    }
                                    if (window.wishlistMetafields.enable_variants == 0) {
                                        defaultVariant = true;
                                    }
                                    variantHtml += `
                                    <option value="${variant.id}" data-price="${variant.price}" data-available=${variant.available} ${variant.available ? '' : 'disabled'}>${variant.title}</option>
                                `;
                                });
                            }

                            let atcButtonHtml = "";
                            atcButton ? (atcButtonHtml = `
                                <button type="button" class="tt-product-atc-main" data-id=${product.id}>
                                    ${atcText}
                                </button>
                            `,
                                window.wishlistMetafields.show_add_to_cart_btn == 0 && (atcButtonHtml = "")) : (atcButtonHtml = `
                                <button type="button" class="tt-product-atc-main" disabled data-id=${product.id}>
                                    ${oosText}
                                </button>
                            `,
                                    window.wishlistMetafields.show_oos_btn == 0 && (atcButtonHtml = ""));

                            let qtyHtml = '<input class="tt-qty-input" name="tt-quantity" type="hidden" value=1 >';
                            window.wishlistMetafields.qty_enable == 1 && (qtyHtml = `
                            <div class="tt-qty-input">
                                <p class="tt-qty-label">Quantity</p>
                                <div class="tt-qty-input-inner">
                                    <button class="tt-qty-count tt-qty-count--minus" data-action="minus" type="button">-</button>
                                    <input class="tt-product-qty" type="number" name="tt-quantity" min="1" value="1">
                                    <button class="tt-qty-count tt-qty-count--add" data-action="add" type="button">+</button>
                                </div>
                            </div>
                            `);

                            let vendorHtml = "";
                            window.wishlistMetafields.show_vendor_name == 1 && (vendorHtml = `
                                <div class="tt-product-vendor-text">
                                    ${product.vendor}
                                </div>
                            `);

                            let productRemoveBtn = `
                            <div class="tt-product-remove-wishlist" data-id=${product.id}>
                                ${wishlistPopupCloseIcon}
                            </div>
                        `;
                            window.isWishlistSharedPage && (productRemoveBtn = "");

                            let productHtml = "";
                            if (isWishlistLandingLayout()) {
                                let exclusiveBadge = (product.tags || []).join(",").toLowerCase().includes("exclusive") ? `<span class="tt-wl-card-badge">Website Exclusive</span>` : ""
                                    , typeLabel = product.type ? product.type.toUpperCase().replace(/\s*•\s*/g, " • ").replace(/,/g, " • ") : (product.vendor || "").toUpperCase()
                                    , brandLabel = product.vendor ? `<span class="tt-wl-card-brand">${product.vendor}</span>` : ""
                                    , emiHtml = product.variants[0]?.price ? `<span class="tt-wl-card-emi">${techno_formatMoney(Math.round(product.variants[0].price / 52))}/mo</span>` : "";
                                productHtml = `
                            <div class="tt-wl-card-media">
                                ${productRemoveBtn}
                                <a href="${product.url}" class="tt-image-a">
                                    <div class="tt-image-wrap">
                                        <img src="${product.featured_image}" alt="${imageAlt}" />
                                    </div>
                                </a>
                                ${exclusiveBadge}
                                ${brandLabel}
                            </div>
                            <div class="tt-product-content">
                                <div class="tt-wl-card-meta">
                                    <span class="tt-wl-card-type">${typeLabel}</span>
                                    <span class="tt-wl-card-rating" aria-hidden="true">★★★★★</span>
                                </div>
                                <a href="${product.url}" class="tt-product-title">
                                    ${product.title}
                                </a>
                                <div class="tt-wl-card-price-row">
                                    <div class="tt-product-price-wrap">
                                        ${techno_formatMoney(product.variants[0].price)}
                                    </div>
                                    ${emiHtml}
                                </div>
                                <select class="${defaultVariant ? "tt-hide" : ""}">
                                    ${variantHtml}
                                </select>
                                <div class="tt-qty-selector">
                                    ${qtyHtml}
                                </div>
                            </div>
                            <div class='tt-error-msg'></div>
                            <div class="tt-product-action">
                                <div class="tt-atc-button-wrap">
                                    ${atcButtonHtml}
                                </div>
                            </div>
                        `
                            } else {
                                productHtml = `
                            <a href="${product.url}" class="tt-image-a">
                                <div class="tt-image-wrap">
                                    <img src="${product.featured_image}" alt="${imageAlt}" />
                                </div>
                            </a>
                            <div class="tt-product-content">
                                ${vendorHtml}
                                <a href="${product.url}" class="tt-product-title">
                                    ${product.title}
                                </a>
                                <div class="tt-product-price-wrap">
                                    ${techno_formatMoney(product.variants[0].price)}
                                </div>
                                <select class="${defaultVariant ? "tt-hide" : ""}">
                                    ${variantHtml}
                                </select>
                                
                                <div class="tt-qty-selector">
                                    ${qtyHtml}
                                </div>
                            </div>
                            <div class='tt-error-msg'></div>
                            <div class="tt-product-action">
                                <div class="tt-atc-button-wrap">
                                    ${atcButtonHtml}
                                </div>
                                ${productRemoveBtn}
                            </div>
                        `
                            }

                            currentProduct.innerHTML = productHtml;
                        } else {
                            // Handle product not found
                            if (pHandle != undefined) {
                                let productRemoveBtn = `
                                <div class="tt-product-remove-wishlist" data-id=${pid}>
                                    ${wishlistPopupCloseIcon}
                                </div>
                            `;
                                const html = `<div class="tt-product-action">
                                ${productRemoveBtn}
                            </div>`;
                                currentProduct.innerHTML = html;

                                // Auto-remove invalid products
                                setTimeout(() => {
                                    if (document.querySelector('.tt-product-list[data-handle="' + pHandle + '"] .tt-product-remove-wishlist') != null) {
                                        document.querySelector('.tt-product-list[data-handle="' + pHandle + '"] .tt-product-remove-wishlist').click();
                                    }
                                }, 100);
                            }
                        }
                    } catch (error) {
                        console.error(`Error fetching product ${pHandle}:`, error);
                        // Handle error gracefully
                        currentProduct.innerHTML = `<div class="tt-error-msg">Error loading product</div>`;
                    }
                });

                await Promise.all(promises);
            };

            // Process products in batches
            for (let i = 0; i < products.length; i += batchSize) {
                const batch = products.slice(i, i + batchSize);
                await processBatch(batch);
            }

            // Re-bind PLP/PDP hearts on newly injected cards only — do not call
            // wishlistButtonsInit() here; it runs wishlistContent() and rebuilds the grid (flicker loop).
            document.querySelectorAll(".tt-wishlist-landing-page-main .tt-product-list--theme-card, .tt-wishlist-share-page-main .tt-product-list--theme-card").forEach(card => upgradeWishlistThemeCardElements(card));
            window.ttWishlistClickEvents();
            typeof wishlistData !== "undefined" && typeof wishlistData.syncInjectedWishlistButtons === "function" && wishlistData.syncInjectedWishlistButtons();
            flag && typeof wishlistData !== "undefined" && wishlistData.initializeSwiperSliders();

        } else if (window.ttWishlistClickEvents(), flag && typeof wishlistData !== "undefined") {
            wishlistData.initializeSwiperSliders();
        }
    }
/**
 * Enhanced API functions with better error handling
 */
const getCategoriesApi = async () => {
    try {
        const url = `${window.wishlistUrl}get/all?customer_id=${window.customerId}`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                shop: window.shop_domin
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        window.getCategoriesData = data;
        return data;
    } catch (error) {
        console.error('Error fetching categories:', error);
        return { status: 500, error: error.message };
    }
};

const getCategoriesDetailsApi = async () => {
    let customerId = window.isWishlistSharedPage || isWishlistSharePageUrl() ? getWishlistShareCustomerId() || window.customerId : window.customerId;
    let url = window.wishlistUrl + "get/product-details?customer_id=" + encodeURIComponent(customerId || "")
        , getCategories = await fetch(url, {
            method: "GET",
            headers: {
                shop: window.shop_domin
            }
        });
    return await getCategories.json()
}
    , addProductInCategoryApi = async (catId, id, guestMode) => {
        const customerId = guestMode ? getGuestCustomerId() : window.customerId;
        let data = {
            customer_id: customerId != null ? String(customerId) : "",
            category_id: catId != null ? String(catId) : "",
            product_id: id != null ? String(id) : "",
            isGuest: !!guestMode,
            is_guest_user: !!guestMode
        };
        if (!data.customer_id || !data.category_id || !data.product_id) {
            console.error('[Super Wishlist] product-add skipped: missing ids', data);
            return { status: 400, message: "missing ids" };
        }
        try {
            let addTowish = await fetch(window.wishlistUrl + "category/product-add", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                },
                body: JSON.stringify(data)
            });
            let payload = null;
            try {
                payload = await addTowish.json();
            } catch (_) {
                payload = { status: addTowish.status, message: "invalid json" };
            }
            if (!addTowish.ok) {
                console.warn('[Super Wishlist] product-add failed', addTowish.status, data, payload);
                return payload && payload.status ? payload : { status: addTowish.status, message: "product-add failed" };
            }
            return payload;
        } catch (error) {
            console.error('[Super Wishlist] product-add network error:', error);
            return { status: 500, message: error?.message || "network error" };
        }
    }
    , removeProductApi = async (id, guestMode, categoryId) => {
        let data = {
            customer_id: guestMode ? getGuestCustomerId() : window.customerId,
            product_id: id,
            isGuest: guestMode,
            is_guest_user: guestMode,
            category_id: categoryId
        }
            , removeProduct = await fetch(window.wishlistUrl + "category/product-delete", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                },
                body: JSON.stringify(data)
            });
        return await removeProduct.json()
    }
    , removeCategoryApi = async id => {
        let data = {
            customer_id: window.customerId,
            category_id: id
        }
            , removeCategory = await fetch(window.wishlistUrl + "category/delete", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                },
                body: JSON.stringify(data)
            });
        return await removeCategory.json()
    }
    , createCategoryApi = async (catName, guestCategoryId, guestMode) => {
        let data = {
            customer_id: guestMode ? getGuestCustomerId() : window.customerId,
            category_id: guestCategoryId,
            category_name: catName,
            customer_email: guestMode ? "" : window.customerEmail,
            customer_name: guestMode ? "" : window.customerName,
            isGuest: !!guestMode,
            is_guest_user: !!guestMode
        };
        if (!data.customer_id || !data.category_name) {
            console.error('[Super Wishlist] category create skipped: missing ids', data);
            return { status: 400, message: "missing ids" };
        }
        try {
            const createCat = await fetch(window.wishlistUrl + "category/create-update", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                },
                body: JSON.stringify(data)
            });
            let payload = null;
            try {
                payload = await createCat.json();
            } catch (_) {
                payload = { status: createCat.status, message: "invalid json" };
            }
            if (!createCat.ok) {
                console.warn('[Super Wishlist] category create failed', createCat.status, data, payload);
                return payload && payload.status ? payload : { status: createCat.status, message: "category create failed" };
            }
            return payload;
        } catch (error) {
            console.error('[Super Wishlist] category create network error:', error);
            return { status: 500, message: error?.message || "network error" };
        }
    },
    moveGuestToCustomerOnLogin = async (guestUserId) => {
        //apply the condition according to guest mode
        let data = {
            customer_id: window.customerId,
            guest_id: guestUserId,
            customer_email: window.customerEmail,
            customer_name: window.customerName,
            // category_id: guestCategoryId,
            // category_name: "Guest Category",
            // wishlist_item: guestWishlistItem
        }
            , updateGuestCat = await fetch(window.wishlistUrl + "move-guest-to-customer-on-login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                },
                body: JSON.stringify(data)
            });

        return await updateGuestCat.json()
    }
    , cartCountApi = async () => {
        let url = window.wishlistUrl + "analytics"
            , data = {
                cart_count: 1
            }
            , cartCount = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                },
                body: JSON.stringify(data)
            });
        return await cartCount.json()
    }
    , pageCountApi = async () => {
        let url = window.wishlistUrl + "analytics"
            , data = {
                page_count: 1
            }
            , pageCount = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                },
                body: JSON.stringify(data)
            });
        return await pageCount.json()
    }
    , submitVoteApi = async (pId, flag) => {
        let url = window.wishlistUrl + "product-vote"
            , data = {
                customer_id: window.customerId,
                product_id: pId,
                vote_count: flag ? 1 : 0
            }
            , voteData = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                },
                body: JSON.stringify(data)
            });
        return await voteData.json()
    }
    , getVoteDataApi = async pId => {
        let url = window.wishlistUrl + "product-vote?product_id=" + pId
            , getVoteData = await fetch(url, {
                method: "GET",
                headers: {
                    shop: window.shop_domin
                }
            });
        return await getVoteData.json()
    }
    , getCustomerVoteDataApi = async pId => {
        let url = window.wishlistUrl + "product-vote?product_id=" + pId + "&customer_id=" + window.customerId
            , getVoteData = await fetch(url, {
                method: "GET",
                headers: {
                    shop: window.shop_domin
                }
            });
        return await getVoteData.json()
    }
    , trendingApi = async () => {
        try {
            let url = window.wishlistUrl + "trending-wishlist";

            let trendingData = await fetch(url, {
                method: "GET",
                headers: {
                    shop: window.shop_domin
                }
            });


            if (!trendingData.ok) {
                console.error('Trending API error:', trendingData.status, trendingData.statusText);
                return { status: trendingData.status, error: trendingData.statusText };
            }

            trendingData = await trendingData.json();

            return trendingData;
        } catch (error) {
            console.error('Trending API fetch error:', error);
            return { status: 500, error: error.message };
        }
    }
    , removeFromCartApi = async (id) => {
        let updates = {};
        updates[id] = 0,
            fetch(window.Shopify.routes.root + "cart/update.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    updates
                })
            }).then(response => response.json()).then(res => {
                window.location.reload()
            }
            ).catch(error => {
                console.error("Error:", error)
            }
            )
    }
    , isHeaderVisible = (el) => {
        if (!el) return false;
        if (el.closest('header, .header, .site-header, #shopify-section-header, .shopify-section-header, [id*="header"]')) {
            const style = window.getComputedStyle(el);
            if (style.display === 'none' || style.visibility === 'hidden') return false;
            // offsetParent is null for fixed/sticky; still accept those in header
            if (el.offsetParent !== null) return true;
            return style.position === 'fixed' || style.position === 'sticky';
        }
        return false;
    }
    , injectHeaderIcon = () => {
        // If a Shopify app block is already rendering the wishlist icon, do nothing
        if (document.querySelector('.shopify-app-block[data-block-handle="wishlist-icon"]')) return;

        // If we already injected (either the web component or the legacy div), do nothing
        if (document.querySelector('super-wishlist-header, .tt-header-heart-icon')) return;

        const compat = (typeof window.superWishlistCompatSelectors === 'function')
            ? window.superWishlistCompatSelectors() : {};

        const cartSelectors = [
            ...(compat.headerCart || []),
            'a[href="/cart"]',
            'a[href*="/cart"]',
            '.header__cart',
            '.header__icon--cart',
            '.site-header__cart',
            '.cart-icon',
            '.cart-link',
            '.js-drawer-open-cart',
            '[data-icon="cart"]',
            '[data-cart-toggle]',
            '.mini-cart',
            'cart-notification',
            'cart-drawer',
            '#cart-icon-bubble'
        ];

        let cartElement = null;
        for (let selector of cartSelectors) {
            let found;
            try { found = document.querySelectorAll(selector); } catch { continue; }
            found.forEach(el => {
                if (isHeaderVisible(el)) cartElement = el;
            });
            if (cartElement) break;
        }

        if (!cartElement) return;

        // Use the <super-wishlist-header> web component â€” same behaviour as before
        // but rendered as a proper Custom Element with live count support.
        const component = document.createElement('super-wishlist-header');

        if (cartElement.tagName === 'A' && cartElement.parentElement?.tagName === 'LI') {
            const li = document.createElement('li');
            li.className = cartElement.parentElement.className;
            li.classList.remove('cart', 'active');
            li.appendChild(component);
            cartElement.parentElement.parentElement.insertBefore(li, cartElement.parentElement);
        } else {
            cartElement.insertAdjacentElement('beforebegin', component);
        }
    }
    , ajaxAddtocart = async items => {
        let add = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                items
            })
        });
        return await add.json()
    }
    , getCartSectionsUrl = () => {
        let url = window.routes?.cart_url || "/cart";
        try {
            url.indexOf("http") === 0 && (url = new URL(url).pathname)
        } catch (error) {}
        return url || "/cart"
    }
    , themeCardAddToCart = async (form, button) => {
        if (!form || !button || button.disabled || button.getAttribute("aria-disabled") === "true")
            return;
        let variantInput = form.querySelector('input[name="id"]')
            , variantId = variantInput?.value;
        if (!variantId)
            return;
        let cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")
            , label = button.querySelector("span:not(.sold-out-message):not(.icon-wrap)")
            , spinner = button.querySelector(".loading__spinner")
            , defaultLabel = label?.textContent || "Add to cart"
            , formData = new FormData(form)
            , config = typeof fetchConfig === "function" ? fetchConfig("javascript") : {
                method: "POST",
                headers: {
                    Accept: "application/javascript"
                }
            };
        if (!formData.get("quantity"))
            formData.set("quantity", 1);
        if (cart && typeof cart.getSectionsToRender === "function") {
            formData.set("sections", cart.getSectionsToRender().map(section => section.id).join(","));
            formData.set("sections_url", getCartSectionsUrl());
            typeof cart.setActiveElement === "function" && cart.setActiveElement(button);
        }
        config.headers = config.headers || {};
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = formData;
        button.setAttribute("aria-disabled", "true");
        button.classList.add("loading");
        spinner?.classList.remove("hidden");
        try {
            let addUrl = window.routes?.cart_add_url || "/cart/add"
                , response = await fetch(addUrl, config).then(res => res.json());
            if (response.status) {
                typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined" && publish(PUB_SUB_EVENTS.cartError, {
                    source: "wishlist-theme-card",
                    productVariantId: variantId,
                    errors: response.errors || response.description,
                    message: response.message
                });
                label && (label.textContent = response.description || response.message || "Error");
                setTimeout(() => {
                    label && (label.textContent = defaultLabel)
                }
                    , 3e3);
                return
            }
            if (!cart) {
                window.location.href = window.routes?.cart_url || "/cart";
                return
            }
            await openThemeCartDrawer(cart, response, button)
        } catch (error) {
            console.error("[Wishlist] Theme card add to cart failed:", error);
            label && (label.textContent = "Error");
            setTimeout(() => {
                label && (label.textContent = defaultLabel)
            }
                , 3e3)
        } finally {
            button.classList.remove("loading");
            button.removeAttribute("aria-disabled");
            spinner?.classList.add("hidden")
        }
    }
    , refreshThemeCartDrawer = async () => {
        let cartUrl = window.routes?.cart_url || "/cart"
            , responseText = await fetch(`${cartUrl}?section_id=cart-drawer`).then(res => res.text())
            , html = new DOMParser().parseFromString(responseText, "text/html");
        ["cart-drawer-items", ".cart-drawer__footer"].forEach(selector => {
            let targetElement = document.querySelector(selector)
                , sourceElement = html.querySelector(selector);
            if (!targetElement || !sourceElement)
                return;
            let imported = document.importNode(sourceElement, !0);
            targetElement.replaceWith(imported);
            imported.tagName === "CART-DRAWER-ITEMS" && customElements.upgrade(imported);
            imported.querySelectorAll("cart-remove-button").forEach(btn => customElements.upgrade(btn))
        }
        );
        return html
    }
    , refreshThemeCartIcon = async () => {
        let cartUrl = window.routes?.cart_url || "/cart"
            , responseText = await fetch(`${cartUrl}?section_id=cart-icon-bubble`).then(res => res.text())
            , doc = new DOMParser().parseFromString(responseText, "text/html")
            , source = doc.querySelector(".shopify-section")
            , target = document.getElementById("cart-icon-bubble");
        target && source && (target.innerHTML = source.innerHTML)
    }
    , openThemeCartDrawer = async (cart, response, triggerButton) => {
        cart || (cart = document.querySelector("cart-drawer"));
        if (!cart)
            return;
        try {
            await refreshThemeCartDrawer()
        } catch (err) {
            console.warn("[Wishlist] Cart drawer refresh failed:", err)
        }
        try {
            await refreshThemeCartIcon()
        } catch (err) {
            console.warn("[Wishlist] Cart icon refresh failed:", err)
        }
        cart.querySelector(".drawer__inner-empty")?.remove();
        cart.classList.remove("is-empty");
        cart.querySelector("cart-drawer-items")?.classList.remove("is-empty");
        typeof cart.setActiveElement === "function" && cart.setActiveElement(triggerButton || document.activeElement);
        setTimeout(() => {
            typeof cart.open === "function" && cart.open(triggerButton)
        }
            , 0)
    }
    ;

(function setupWishlistThemeCardCart() {
    if (window.__ttWishlistThemeCardCartBound)
        return;
    window.__ttWishlistThemeCardCartBound = !0;
    document.addEventListener("submit", event => {
        let form = event.target?.closest?.(".tt-wishlist-landing-page-main .tt-product-list--theme-card form[data-type='add-to-cart-form']");
        if (!form)
            return;
        event.preventDefault();
        event.stopImmediatePropagation();
        themeCardAddToCart(form, form.querySelector("button[type='submit']"))
    }
        , !0)
}
)();
(function setupWishlistQuickViewFallback() {
    if (window.__ttWishlistQuickViewFallback)
        return;
    window.__ttWishlistQuickViewFallback = !0;
    document.addEventListener("click", event => {
        const button = event.target?.closest?.(".tt-wishlist-landing-page-main .tt-product-list--theme-card .quick-add__ModalOpen, .tt-wishlist-share-page-main .tt-product-list--theme-card .quick-add__ModalOpen");
        if (!button)
            return;
        const opener = button.closest("modal-opener");
        if (!opener)
            return;
        const modalRef = opener.getAttribute("data-modal") || "";
        const modalId = modalRef.replace(/^#/, "");
        const modal = modalId ? document.getElementById(modalId) : null;
        if (!modal || typeof modal.show !== "function")
            return;
        event.preventDefault();
        event.stopPropagation();
        modal.show(button)
    }
        , !0)
}
)();

(function patchWishlistCartSectionsUrl() {
    if (window.__ttWishlistCartSectionsPatch)
        return;
    window.__ttWishlistCartSectionsPatch = !0;
    let nativeFetch = window.fetch.bind(window);
    window.fetch = function(input, init) {
        let url = typeof input === "string" ? input : input?.url || ""
            , shouldPatch = typeof isWishlistPageContext === "function" && isWishlistPageContext() && init?.body && (url.includes("/cart/change") || url.includes("/cart/add"));
        if (shouldPatch) {
            try {
                typeof init.body === "string" && init.body.trim().startsWith("{") ? (() => {
                    let body = JSON.parse(init.body);
                    "sections_url"in body && (body.sections_url = getCartSectionsUrl(),
                        init = {
                            ...init,
                            body: JSON.stringify(body)
                        })
                }
                )() : typeof FormData !== "undefined" && init.body instanceof FormData && init.body.has("sections_url") && init.body.set("sections_url", getCartSectionsUrl())
            } catch (error) {}
        }
        return nativeFetch(input, init).then(response => {
            shouldPatch && setTimeout(() => {
                document.querySelectorAll("cart-drawer-items cart-remove-button").forEach(btn => {
                    try {
                        customElements.upgrade(btn)
                    } catch (error) {}
                }
                )
            }
                , 0);
            return response
        }
        )
    }
}
)();

// M4: Optional merchant CSS selector overrides from wishlist metafields (additive).
window.superWishlistCompatSelectors = () => {
    const meta = window.wishlistMetafields || {};
    let collection = meta.collection;
    if (typeof collection === "string") {
        try { collection = JSON.parse(collection); } catch { collection = {}; }
    }
    collection = collection || {};
    let pdp = meta.pdp_auto_placement;
    if (typeof pdp === "string") {
        try { pdp = JSON.parse(pdp); } catch { pdp = {}; }
    }
    pdp = pdp || {};
    const split = (val) => {
        if (!val) return [];
        if (Array.isArray(val)) return val.map(String).map(s => s.trim()).filter(Boolean);
        return String(val).split(",").map(s => s.trim()).filter(Boolean);
    };
    return {
        grid: split(collection.grid_selectors || collection.compat_grid_selectors),
        cards: split(collection.card_selectors || collection.compat_card_selectors),
        images: split(collection.image_selectors || collection.compat_image_selectors),
        headerCart: split(collection.header_cart_selectors || collection.compat_header_cart_selectors),
        pdpPosition: pdp.position || null,
        pdpSelectorLocation: pdp.selectorLocation || null
    };
};

// C2: Queue early injector reinits until setAllData has parsed metafields.
(function setupSuperWishlistReadyGate() {
    let ready = false;
    const queue = [];
    const timeoutId = setTimeout(() => {
        if (!ready) {
            console.warn('[Super Wishlist] Ready gate timed out; continuing.');
            window.markSuperWishlistReady();
        }
    }, 10000);

    window.whenSuperWishlistReady = (fn) => {
        if (typeof fn !== 'function') return;
        if (ready) {
            fn();
            return;
        }
        queue.push(fn);
    };

    window.markSuperWishlistReady = () => {
        if (ready) return;
        ready = true;
        clearTimeout(timeoutId);
        const pending = queue.splice(0, queue.length);
        pending.forEach((fn) => {
            try {
                fn();
            } catch (error) {
                console.error('[Super Wishlist] Ready-gate callback failed:', error);
            }
        });
    };
})();

class WishlistPDP {
    constructor() {
        this.setAllData();

    }
    setAllData = async () => {
        try {
            await this.setGuest();
        } catch (error) {
            console.error('[Super Wishlist] setGuest failed during bootstrap:', error);
        }
        this.storeId = window.shop_domin;
        this.wishlistMeta = window.wishlistMetafields;
        this.customerExist = window.customerExist;
        this.customerName = window.customerName;
        this.customerEmail = window.customerEmail;
        this.wishlistUrl = window.wishlistUrl;
        this.wishlistPageUrl = "/apps/wishlist/wishlist-landing";
        window.isWishlistSharedPage = !1;
        if (applyWishlistSharePageSession()) {
            this.customerExist = !0;
            this.customerId = window.customerId
        } else if (this.customerExist) {
            this.customerId = window.customerId
        }
        if (window.isShopifyLoggedIn === !0 && window.shopifyCustomerId && !window.isWishlistSharedPage) {
            restoreShopifyCustomerId();
            this.customerId = window.customerId;
            this.customerExist = !0;
        }

        // Parse any metafield sub-properties that arrive as JSON strings.
        // Shopify metafields are often serialised as text â€” normalise them here
        // once so every method downstream gets a proper object.
        const _parseIfString = (val) => {
            if (typeof val !== 'string') return val;
            try { return JSON.parse(val); } catch { return val; }
        };
        if (this.wishlistMeta) {
            this.wishlistMeta.button_setting = _parseIfString(this.wishlistMeta.button_setting);
            this.wishlistMeta.button_style = _parseIfString(this.wishlistMeta.button_style);
            this.wishlistMeta.collection = _parseIfString(this.wishlistMeta.collection);
            this.wishlistMeta.vote_btn = _parseIfString(this.wishlistMeta.vote_btn);
            this.wishlistMeta.trending = _parseIfString(this.wishlistMeta.trending);
            this.wishlistMeta.language2 = _parseIfString(this.wishlistMeta.language2);
            this.wishlistMeta.share_wishlist_data = _parseIfString(this.wishlistMeta.share_wishlist_data);
            this.wishlistMeta.pdp_auto_placement = _parseIfString(this.wishlistMeta.pdp_auto_placement);
        }
        // C2: Allow queued wishlistButtonsInit / wishlistInit after meta is usable.
        if (typeof window.markSuperWishlistReady === 'function') {
            window.markSuperWishlistReady();
        }
        // (this.wishlistMeta.show_trending_wishlist == "1" || this.wishlistMeta.show_trending_wishlist == 1) && this.trendingWishlistSetup(),
        this.trendingWishlistSetup(),
            this.init(),
            document.addEventListener("click", e => {
                const plpWrapper = e.target && e.target.closest && e.target.closest(".tt-wishlist-plp-btn-main");
                if (plpWrapper) {
                    plpWrapper.closest(".tt-wishlist-landing-page-main") && (e.preventDefault(),
                        e.stopPropagation());
                    this.plpButtonClick(plpWrapper);
                    return;
                }
                // PDP auto-inject can mount after clickEvents; delegate so hearts always respond.
                const pdpBtn = e.target && e.target.closest && e.target.closest(".wishlist-pdp-btn-main .wishlist-pdp-btn-wrap");
                if (pdpBtn) {
                    this.pdpButtonClick(e);
                }
            }
            )
    }
    clickEvents = () => {
        let wishlist_btn = document.querySelectorAll(".wishlist-pdp-btn-main .wishlist-pdp-btn-wrap");
        wishlist_btn.length > 0 && wishlist_btn.forEach(item => {
            item.removeEventListener("click", this.pdpButtonClick),
                item.addEventListener("click", this.pdpButtonClick)
        }
        );
        let categoryPopupClose = document.querySelector(".wishlist-create-category-popup .tt-category-close");
        categoryPopupClose && (categoryPopupClose.removeEventListener("click", this.categoryPopupShow),
            categoryPopupClose.addEventListener("click", () => this.categoryPopupShow(!0))),
            document.querySelectorAll(".wishlist-create-category-popup .tt-form-group .tt-add-wishlist").forEach(ele => {
                ele.removeEventListener("click", this.addProductInCategory),
                    ele.addEventListener("click", this.addProductInCategory)
            }
            );
        let createCategory = document.querySelector(".wishlist-create-category-popup .tt-form-new-group .tt-add-wishlist");
        createCategory && (createCategory.removeEventListener("click", this.createCategoryEvent),
            createCategory.addEventListener("click", this.createCategoryEvent)),
            [".wishlist-floting-btn-wrap", ".wishlist-page-widget,.tt-product-wishlist"].forEach(btnClass => {
                document.querySelectorAll(btnClass).forEach(ele => {
                    ele.removeEventListener("click", this.wishlistBtnEvent),
                        ele.addEventListener("click", this.wishlistBtnEvent)
                }
                )
            }
            ),
            document.querySelectorAll(".tt-tab-header-wrap .tt-tab-title").forEach(ele => {
                ele.removeEventListener("click", this.tabChangeEvent),
                    ele.addEventListener("click", this.tabChangeEvent)
            }
            );
        let detailsPopupClose = document.querySelector(".tt-wishlist-details-popup .tt-details-close");
        detailsPopupClose && (detailsPopupClose.removeEventListener("click", this.detailsPopupCloseEvent),
            detailsPopupClose.addEventListener("click", this.detailsPopupCloseEvent));
        let detailsPopupOverlay = document.querySelector(".tt-wishlist-details-popup .tt-popup-overlay");
        detailsPopupOverlay && (detailsPopupOverlay.removeEventListener("click", this.detailsPopupCloseEvent),
            detailsPopupOverlay.addEventListener("click", this.detailsPopupCloseEvent));
        let shareButton = document.querySelector(".tt-wishlist-share-btn");
        shareButton && (shareButton.removeEventListener("click", this.shareButtonEvent),
            shareButton.addEventListener("click", e => this.shareButtonEvent()));
        let addAllButton = document.querySelector(".tt-wishlist-add-all-btn");
        addAllButton && (addAllButton.removeEventListener("click", this.addAllToCartEvent),
            addAllButton.addEventListener("click", e => this.addAllToCartEvent(e.currentTarget)));
        let sharePopupClose = document.querySelector(".tt-share-wishlist-popup .tt-share-wishlist-close");
        sharePopupClose && (sharePopupClose.removeEventListener("click", this.shareButtonEvent),
            sharePopupClose.addEventListener("click", e => this.shareButtonEvent(!0)));
        let sharePopupOverlay = document.querySelector(".tt-share-wishlist-popup .tt-popup-overlay");
        sharePopupOverlay && (sharePopupOverlay.removeEventListener("click", this.shareButtonEvent),
            sharePopupOverlay.addEventListener("click", e => this.shareButtonEvent(!0))),
            document.querySelectorAll(".tt-wishlist-details-main .tt-category-remove").forEach(ele => {
                ele.removeEventListener("click", this.removeCategoryEvent),
                    ele.addEventListener("click", e => {
                        let that = e.currentTarget;
                        this.removeCategoryEvent(that)
                    }
                    )
            }
            ),
            document.querySelectorAll(".tt-wishlist-details-main .tt-product-remove-wishlist").forEach(ele => {
                ele.removeEventListener("click", this.removeProductEvent),
                    ele.addEventListener("click", e => {
                        let that = e.currentTarget;
                        this.removeProductEvent(that)
                    }
                    )
            }
            ),
            document.querySelectorAll(".tt-product-list .tt-product-atc-main").forEach(ele => {
                ele.removeEventListener("click", this.addToCartEvent),
                    ele.addEventListener("click", e => {
                        let that = e.currentTarget;
                        this.addToCartEvent(that)
                    }
                    )
            }
            ),
            document.querySelectorAll(".wishlist-pdp-btn-main .tt-vote-btn-wrap").forEach(ele => {
                ele.removeEventListener("click", this.voteButtonEvent),
                    ele.addEventListener("click", this.voteButtonEvent)
            }
            ),
            document.querySelectorAll(".ttcopybtn").forEach(ele => {
                ele.removeEventListener("click", this.copyButtonEvent),
                    ele.addEventListener("click", this.copyButtonEvent)
            }
            ),
            document.querySelectorAll(".tt-product-list .tt-qty-count").forEach(ele => {
                ele.removeEventListener("click", this.qtyClickEvent),
                    ele.addEventListener("click", this.qtyClickEvent)
            }
            ),
            document.querySelectorAll(".tt-product-list .tt-product-qty").forEach(ele => {
                ele.removeEventListener("change", this.qtyInputChangeEvent),
                    ele.addEventListener("change", e => {
                        let that = e.currentTarget;
                        this.qtyInputChangeEvent(that)
                    }
                    )
            }
            ),
            document.querySelectorAll(".tt-wishlist-details-main .tt-product-content select").forEach(ele => {
                ele.removeEventListener("change", this.variantChangeEvent),
                    ele.addEventListener("change", e => {
                        let that = e.currentTarget;
                        this.variantChangeEvent(that)
                    }
                    )
            }
            )
    }
        ;
    pdpButtonClick = async e => {
        // Shared flag for direct bind + document delegation (prevents double add).
        if (e && e.__ttWishlistPdpHandled)
            return;
        if (e)
            e.__ttWishlistPdpHandled = !0;
        let that = (e.target && e.target.closest && e.target.closest(".wishlist-pdp-btn-wrap"))
                || (e.currentTarget && e.currentTarget.classList && e.currentTarget.classList.contains("wishlist-pdp-btn-wrap") && e.currentTarget)
                || null
            , parent = that && that.closest ? that.closest(".wishlist-pdp-btn-main") : null;
        if (!parent || !that) return;
        let id = parseInt(parent.getAttribute("data-pid"))
            , handle = parent.getAttribute("data-handle");
        if (isLoggedInWishlistCustomer())
            if (that.classList.contains("active"))
                this.deleteProduct(id);
            else if (isCategoryEnabled())
                await this.openCategoryPopupForProduct(id, handle);
            else
                this.addProductInWithoutCategory(id, handle);
        else
            isTruthySetting(window.wishlistMetafields?.guest_wishlist) ? that.classList.contains("active") ? this.deleteProductLocal(id, handle) : this.addToWishlistLocal(id, handle) : location.href = "/account/login"
    }
        ;
    plpButtonClick = async e => {
        let parent = e?.closest?.(".tt-wishlist-plp-btn-main") || e?.currentTarget?.closest?.(".tt-wishlist-plp-btn-main") || (e?.classList?.contains?.("tt-wishlist-plp-btn-main") ? e : null);
        if (!parent)
            return;
        let that = parent.querySelector(".wishlist-plp-btn-wrap");
        if (!that)
            return;
        let id = parseInt(parent.getAttribute("data-pid"), 10)
            , handle = parent.getAttribute("data-handle");
        if (isWishlistLandingLayout() && !window.isWishlistSharedPage && parent.closest(".tt-product-list")) {
            if (isLoggedInWishlistCustomer())
                await this.deleteProduct(id, handle);
            else if (isTruthySetting(window.wishlistMetafields?.guest_wishlist))
                await this.deleteProductLocal(id, handle);
            else
                location.href = "/account/login";
            return
        }
        parent.classList.contains("tt-cart-btn") && that.querySelectorAll("span")?.forEach(ele => {
                ele.innerHTML = "Saving..."
            }
            );
        let isCartProduct = !1
            , vId = ""
            ;
        parent.classList.contains("tt-cart-btn") && (vId = parseInt(parent.getAttribute("data-vid")),
            isCartProduct = !0);
        if (isLoggedInWishlistCustomer())
            if (!isCartProduct && that.classList.contains("active"))
                this.deleteProduct(id);
            else if (isCartProduct)
                this.addProductInSavedForLater(id, vId, handle);
            else if (isCategoryEnabled())
                await this.openCategoryPopupForProduct(id, handle);
            else
                this.addProductInWithoutCategory(id, handle);
        else
            isTruthySetting(window.wishlistMetafields?.guest_wishlist) ? !isCartProduct && that.classList.contains("active") ? this.deleteProductLocal(id, handle) : (this.addToWishlistLocal(id, handle),
                isCartProduct && removeFromCartApi(vId)) : location.href = "/account/login"
    }
        ;
    openCategoryPopupForProduct = async (id, handle) => {
        let popupWrap = document.querySelector(".wishlist-create-category-popup-main");
        if (!popupWrap || !popupWrap.querySelector(".wishlist-create-category-popup")) {
            await this.createCategory();
            popupWrap = document.querySelector(".wishlist-create-category-popup-main");
        }
        if (!popupWrap) {
            // Category popup failed to build — still add via default path so click is never a no-op.
            await this.addProductInWithoutCategory(id, handle);
            return;
        }
        popupWrap.setAttribute("data-pid", id);
        popupWrap.setAttribute("data-handle", handle);
        this.categoryPopupShow();
    }
        ;
    // save for later in main wishlist, please remove this if you not want and change the above function
    addProductInSavedForLater = async (id, vId, handle) => {
        if (window.getCategoriesData) {
            let data = window.getCategoriesData.data
                , catId = "";
            data.forEach(ele => {
                ele.category_name == "Default Category" && (catId = ele.category_id)
            }
            ),
                catId == "" ? (await createCategoryApi("Default Category")).status == 200 && ((await getCategoriesApi())?.data?.forEach(ele => {
                    ele.category_name == "Default Category" && (catId = ele.category_id)
                }
                ),
                    id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && removeFromCartApi(vId)) : id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && removeFromCartApi(vId)
        }
    }
        ;
    addProductInSaved = async (id, vId, handle) => {
        if (window.getCategoriesData) {
            let data = window.getCategoriesData.data
                , catId = "";
            data.forEach(ele => {
                ele.category_name == "Save for later" && (catId = ele.category_id)
            }
            ),
                catId == "" ? (await createCategoryApi("Save for later")).status == 200 && ((await getCategoriesApi())?.data?.forEach(ele => {
                    ele.category_name == "Save for later" && (catId = ele.category_id)
                }
                ),
                    id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && removeFromCartApi(vId)) : id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && removeFromCartApi(vId)
        }
    }
        ;
    addProductInWithoutCategory = async (id, handle) => {
        try {
            if (!window.getCategoriesData || !window.getCategoriesData.data) {
                await getCategoriesApi();
            }
            let data = window.getCategoriesData?.data;
            if (!data) {
                const created = await createCategoryApi("Default Category");
                if (created?.status == 200)
                    await getCategoriesApi();
                data = window.getCategoriesData?.data;
            }
            if (!data)
                return;
            let catId = "";
            data.forEach(ele => {
                ele.category_name == "Default Category" && (catId = ele.category_id)
            });
            if (catId == "") {
                const created = await createCategoryApi("Default Category");
                if (created?.status == 200) {
                    (await getCategoriesApi())?.data?.forEach(ele => {
                        ele.category_name == "Default Category" && (catId = ele.category_id)
                    });
                }
            } else {
                (await getCategoriesApi())?.data?.forEach(ele => {
                    ele.category_name == "Default Category" && (catId = ele.category_id)
                });
            }
            if (id && catId && (await addProductInCategoryApi(catId, id)).status == 200) {
                this.categoryPopupShow(!0);
                showToastMsg(handle, !0);
                this.getCategoryAllData();
                wishlistContent();
            }
        } catch (error) {
            console.error('[Super Wishlist] addProductInWithoutCategory failed:', error);
        }
    }
        ;
    copyButtonEvent = e => {
        let that = e.target
            , copyUrl = that.closest(".tt-share-input-url")?.querySelector(".tt-share-input")?.value;
        if (!copyUrl)
            return;
        const markCopied = () => that.classList.add("active");
        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(copyUrl).then(markCopied).catch(() => { });
            return;
        }
        const input = that.closest(".tt-share-input-url")?.querySelector(".tt-share-input");
        if (input) {
            input.removeAttribute("disabled");
            input.select();
            try {
                document.execCommand("copy") && markCopied();
            } catch (err) { }
            input.setAttribute("disabled", "");
        }
    }
        ;
    qtyClickEvent = e => {
        let that = e.target
            , parent = that.closest(".tt-qty-input")
            , inputEle = parent.querySelector(".tt-product-qty")
            , qtyMin = parseInt(inputEle.getAttribute("min"))
            , actionType = that.getAttribute("data-action")
            , qty = parseInt(inputEle.value);
        actionType == "add" ? (qty += 1,
            qty >= qtyMin + 1 && parent.querySelector(".tt-qty-count--minus").removeAttribute("disabled")) : (qty = qty <= qtyMin ? qtyMin : qty -= 1,
                qty == qtyMin && parent.querySelector(".tt-qty-count--minus").setAttribute("disabled", !0)),
            inputEle.value = qty
    }
        ;
    qtyInputChangeEvent = that => {
        let minusBtn = that.closest(".tt-qty-input").querySelector(".tt-qty-count--minus")
            , qtyMin = parseInt(that.getAttribute("min"))
            , qty = parseInt(that.value);
        isNaN(qty) || qty <= qtyMin ? (that.value = qtyMin,
            minusBtn.setAttribute("disabled", !0)) : (that.value = qty,
                minusBtn.removeAttribute("disabled"))
    }
        ;
    voteButtonEvent = async e => {
        if (this.wishlistMeta.vote_btn.enable == 0 || !this.wishlistMeta.vote_btn.enable || !this.customerExist)
            return !1;
        let that = e.currentTarget
            , pId = that.closest(".wishlist-pdp-btn-main").getAttribute("data-pid")
            , shouldVote = !that.classList.contains("active");
        if ((await submitVoteApi(pId, shouldVote)).status == 200) {
            shouldVote ? that.classList.add("active") : that.classList.remove("active");
            this.setupVoteBtn();
        }
    }
        ;
    addProductInCategory = async e => {
        let that = e.target
            , parent = that.closest(".wishlist-create-category-popup-main")
            , id = parent.getAttribute("data-pid")
            , handle = parent.getAttribute("data-handle")
            , catId = that.getAttribute("cat-id")
            , categoryName = that.closest(".tt-form-group")?.querySelector(".wishlist-p-tag")?.textContent?.trim() || "";
        id && catId && (await addProductInCategoryApi(catId, id)).status == 200 && (this.categoryPopupShow(!0),
            showToastMsg(handle, !1, categoryName),
            this.getCategoryAllData(),
            wishlistContent())
    }
        ;
    detailsPopupCloseEvent = () => {
        wishlistPopupOpen(!0)
    }
        ;
    createCategoryEvent = async e => {
        let catName = e.target.closest(".wishlist-create-category-popup-main").querySelector(".tt-form-new-group input").value;
        catName && (await createCategoryApi(catName)).status == 200 && this.createCategory()
    }
        ;
    wishlistBtnEvent = () => {
        if (document.querySelector(".tt-wishlist-landing-page-main"))
            return;
        let module = window.wishlistMetafields.button_setting.wishlist_module;
        let popupWrap = document.querySelector(".tt-wishlist-details-popup");
        if ((module == "popup" || module == "drawer") && popupWrap) {
            pageCountApi();
            wishlistPopupOpen();
            return;
        }
        location.href = "/apps/wishlist/wishlist-landing"
    }
        ;
    tabChangeEvent = e => {
        let tabId = e.target.getAttribute("data-tab")
            , allTabHead = document.querySelectorAll(".tt-tab-header-wrap li")
            , allTabBody = document.querySelectorAll(".tt-tab-content-wrap .tab-content-inner-wrap");
        allTabHead.forEach(ele => {
            ele.getAttribute("data-tab") == tabId ? ele.classList.add("active") : ele.classList.remove("active")
        }
        ),
            allTabBody.forEach(ele => {
                ele.getAttribute("data-tab") == tabId ? ele.classList.add("active") : ele.classList.remove("active")
            }
            )
    }
        ;
    shareButtonEvent = async flag => {
        let popupWrap = document.querySelector(".tt-share-wishlist-popup");
        if (!popupWrap)
            return;
        if (flag) {
            document.body.classList.remove("tt-overflow-hidden");
            popupWrap.classList.remove("active");
            return
        }
        let shareButton = document.querySelector(".tt-wishlist-share-btn");
        shareButton && (shareButton.disabled = !0,
            shareButton.classList.add("loading"));
        try {
            if (!await this.prepareShareWishlist()) {
                console.warn("[Wishlist] Share preparation failed. canShow:", canShowShareWishlist(), "loggedIn:", isLoggedInWishlistCustomer(), "localItems:", hasLocalWishlistItems(), "guestId:", getGuestCustomerId());
                return
            }
            applySharePopupOptions(popupWrap, this.wishlistMeta?.share_wishlist_data);
            document.body.classList.add("tt-overflow-hidden");
            popupWrap.classList.add("active")
        } finally {
            shareButton && (shareButton.disabled = !1,
                shareButton.classList.remove("loading"))
        }
    }
        ;
    removeCategoryEvent = async e => {
        let id = e.getAttribute("data-cid");
        (await removeCategoryApi(id)).status == 200 && (this.createCategory(),
            wishlistContent())
    }
        ;
    removeProductEvent = async e => {
        let id = e.getAttribute("data-id");
        if (this.customerExist) {
            (await removeProductApi(id)).status == 200 && (this.removeWishlistProductFromUI(id),
                this.createCategory(),
                await this.getCategoryAllData(),
                typeof window.wishlistUpdateHeaderCount === "function" && window.wishlistUpdateHeaderCount(),
                this.shouldRefreshWishlistContentAfterRemove() && wishlistContent())
        } else
            window.wishlistMetafields.guest_wishlist == 1 && this.deleteProductLocal(id)
    }
        ;
    addAllToCartEvent = async btn => {
        if (!btn || btn.disabled)
            return;
        let defaultLabel = btn.textContent || "Add All to Cart"
            , items = []
            , atcButtons = document.querySelectorAll(".tt-wishlist-landing-page-main .tt-product-list .tt-product-atc-main:not(:disabled)");
        btn.disabled = !0;
        btn.textContent = "Adding...";
        if (!atcButtons.length && document.querySelector(".tt-wishlist-landing-page-main .tt-product-list--theme-card")) {
            document.querySelectorAll(".tt-wishlist-landing-page-main .tt-product-list--theme-card form[data-type='add-to-cart-form']").forEach(form => {
                let variantInput = form.querySelector("input[name='id']")
                    , submitBtn = form.querySelector("button[name='add']");
                if (!variantInput || !submitBtn || submitBtn.disabled)
                    return;
                items.push({
                    id: parseInt(variantInput.value, 10),
                    quantity: 1,
                    properties: {
                        _is_wishlist_product: !0
                    }
                })
            }
            );
            if (!items.length) {
                btn.disabled = !1;
                btn.textContent = defaultLabel;
                return
            }
            let themeAtc = await ajaxAddtocart(items);
            if (themeAtc.status == 422) {
                btn.disabled = !1;
                btn.textContent = defaultLabel;
                return
            }
            cartCountApi();
            let cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
            if (cart) {
                await openThemeCartDrawer(cart, themeAtc, btn)
            } else if (window.wishlistMetafields?.stay_on_wishlist_after_cart == 0) {
                location.href = "/cart"
            }
            btn.textContent = "Added To Cart";
            setTimeout(() => {
                btn.disabled = !1;
                btn.textContent = defaultLabel
            }
                , 1800);
            return
        }
        if (!atcButtons.length) {
            btn.disabled = !1;
            btn.textContent = defaultLabel;
            return
        }
        atcButtons.forEach(atcBtn => {
            let parent = atcBtn.closest(".tt-product-list")
                , select = parent?.querySelector(".tt-product-content select");
            if (!select || !select.selectedOptions.length)
                return;
            let selectedOption = select.selectedOptions[0]
                , availability = selectedOption.getAttribute("data-available");
            if (!(availability == "true" || availability == !0))
                return;
            let quantityInput = parent.querySelector("input[name=tt-quantity]")
                , quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
            quantity > 1 || (quantity = 1);
            items.push({
                id: parseInt(selectedOption.getAttribute("value"), 10),
                quantity,
                properties: {
                    _is_wishlist_product: !0
                }
            })
        }
        );
        if (!items.length) {
            btn.disabled = !1;
            btn.textContent = defaultLabel;
            return
        }
        let atc = await ajaxAddtocart(items);
        if (atc.status == 422) {
            btn.disabled = !1;
            btn.textContent = defaultLabel;
            return
        }
        cartCountApi();
        btn.textContent = "Added To Cart";
        window.wishlistMetafields?.stay_on_wishlist_after_cart == 0 && (location.href = "/cart");
        setTimeout(() => {
            btn.disabled = !1;
            btn.textContent = defaultLabel
        }
            , 1800)
    }
        ;
    addToCartEvent = async e => {
        e.innerHTML = "Adding...";
        let parent = e.closest(".tt-product-list")
            , pId = e.getAttribute("data-id")
            , selectedOption = parent.querySelector(".tt-product-content select").selectedOptions[0]
            , availability = selectedOption.getAttribute("data-available")
            , id = parseInt(selectedOption.getAttribute("value"))
            , atcText = window.wishlistMetafields.language2.btn_move_to_cart
            , quantity = parent.querySelector("input[name=tt-quantity]");
        if (quantity = parseInt(quantity.value),
            quantity > 1 || (quantity = 1),
            availability && availability == "true" || availability == !0) {
            let atc = await ajaxAddtocart([{
                id,
                quantity,
                properties: {
                    _is_wishlist_product: !0
                }
            }]);
            if (atc.status == 422)
                return parent.querySelector(".tt-error-msg").innerHTML = atc.description,
                    e.innerHTML = atcText,
                    setTimeout(() => {
                        parent.querySelector(".tt-error-msg").innerHTML = ""
                    }
                        , 5e3),
                    !1;
            if (cartCountApi(),
                window.wishlistMetafields.remove_product_after_cart == 1)
                if (e.innerHTML = atcText,
                    this.customerExist) {
                    if (window.isWishlistSharedPage)
                        return !1;
                    (await removeProductApi(pId)).status == 200 && (wishlistContent(),
                        this.createCategory()),
                        window.wishlistMetafields.stay_on_wishlist_after_cart == 0 && (location.href = "/cart")
                } else
                    window.wishlistMetafields.guest_wishlist == 1 && (this.deleteProductLocal(pId),
                        wishlistContent());
            else
                e.innerHTML = "Added To Cart",
                    window.wishlistMetafields.stay_on_wishlist_after_cart == 0 && (location.href = "/cart")
        }
    }
        ;
    variantChangeEvent = e => {
        let parent = e.closest(".tt-product-list")
            , price = e.selectedOptions[0]?.getAttribute("data-price")
            , priceEle = parent?.querySelector(".tt-product-price-wrap")
            , emiEle = parent?.querySelector(".tt-wl-card-emi");
        price && priceEle && (priceEle.innerHTML = techno_formatMoney(price));
        price && emiEle && (emiEle.innerHTML = `${techno_formatMoney(Math.round(price / 52))}/mo`)
    }
        ;
    categoryPopupShow = flag => {
        let popupWrap = document.querySelector(".wishlist-create-category-popup-main");
        if (!popupWrap)
            return;
        flag ? (document.body.classList.remove("tt-overflow-hidden"),
            popupWrap.classList.remove("active")) : (document.body.classList.add("tt-overflow-hidden"),
                popupWrap.classList.add("active"))
    }
        ;
    getCategoryAllData = async data => {
        let getCategories = data;
        if (getCategories || (getCategories = await getCategoriesApi()),
            getCategories.status != 200)
            return !1;
        let available_pro = [];
        if (getCategories.data && getCategories.data.length > 0) {
            let pdpButtons = document.querySelectorAll(".wishlist-pdp-btn-main")
                , plpButtons = document.querySelectorAll(".tt-wishlist-plp-btn-main");
            getCategories.data.length > 0 ? (getCategories.data.forEach((item, i) => {
                available_pro = available_pro.concat(item.product_ids)
            }
            ),
                available_pro = available_pro.map(id => String(id)),
                pdpButtons.length > 0 && pdpButtons.forEach((item, i) => {
                    let item_id = String(item.getAttribute("data-pid"));
                    available_pro.includes(item_id) ? item.querySelector(".wishlist-pdp-btn-wrap")?.classList.add("active") : item.querySelector(".wishlist-pdp-btn-wrap")?.classList.remove("active")
                }
                ),
                plpButtons.length > 0 && plpButtons.forEach((item, i) => {
                    let item_id = String(item.getAttribute("data-pid"));
                    available_pro.includes(item_id) ? item.querySelector(".wishlist-plp-btn-wrap")?.classList.add("active") : item.querySelector(".wishlist-plp-btn-wrap")?.classList.remove("active")
                }
                )) : (pdpButtons.length > 0 && pdpButtons.forEach((item, i) => {
                    item.querySelector(".wishlist-pdp-btn-wrap")?.classList.remove("active")
                }
                ),
                    plpButtons.length > 0 && plpButtons.forEach((item, i) => {
                        item.querySelector(".wishlist-plp-btn-wrap")?.classList.remove("active")
                    }
                    ))
        }
    }
        ;
    fetchProductExistLocal = () => {
        let productsData = techno_getCookie("wishlist");
        let flag = false;
        let curr_pro_id = [];
        let allpro = document.querySelectorAll(".wishlist-pdp-btn-main");
        let plpButtons = document.querySelectorAll(".tt-wishlist-plp-btn-main");

        if (productsData) {
            try {
                productsData = JSON.parse(productsData);
                productsData.forEach(item => {
                    curr_pro_id.push(item.p_id);
                });
            } catch (error) {
                console.error('Error parsing productsData:', error);
                productsData = []; // Reset to an empty array if JSON is invalid
            }
        } else {
            productsData = []; // Initialize as an empty array if cookie doesn't exist
        }

        allpro.length > 0 && allpro.forEach((item, i) => {
            let item_id = parseInt(item.getAttribute("data-pid"));
            if (curr_pro_id.includes(item_id)) {
                item.querySelector(".wishlist-pdp-btn-wrap")?.classList.add("active");
                flag = true;
            } else {
                item.querySelector(".wishlist-pdp-btn-wrap")?.classList.remove("active");
            }
        });

        plpButtons.length > 0 && plpButtons.forEach((item, i) => {
            let item_id = String(item.getAttribute("data-pid"));
            curr_pro_id.map(String).includes(item_id) ? item.querySelector(".wishlist-plp-btn-wrap")?.classList.add("active") : item.querySelector(".wishlist-plp-btn-wrap")?.classList.remove("active")
        });
    }
        ;
    addToWishlistLocal = async (p_id, p_handle) => {
        let productsData = [];
        let guest_category_id = null;

        try {
            const rawProducts = techno_getCookie("wishlist");
            productsData = rawProducts ? JSON.parse(rawProducts) : [];
            if (!Array.isArray(productsData)) productsData = [];
        } catch (error) {
            console.error("Error parsing wishlist cookie:", error);
            productsData = [];
        }

        try {
            const rawCategory = techno_getCookie("wishlist_category");
            if (rawCategory) {
                const parsedCategory = JSON.parse(rawCategory);
                guest_category_id = parsedCategory?.[0]?.category_id || null;
            }
        } catch (error) {
            console.error("Error parsing wishlist_category cookie:", error);
            guest_category_id = null;
        }

        if (!guest_category_id) {
            guest_category_id = "CAT-" + Math.floor(Math.random() * 100000);
            this.persistGuestCategoryId(guest_category_id);
        }

        const alreadyLocal = productsData.some(item => String(item.p_id) === String(p_id));
        if (!alreadyLocal) {
            productsData.push({ p_id, p_handle });
            techno_setCookie("wishlist", JSON.stringify(productsData), 100);
        }

        showToastMsg(p_handle, true);
        this.fetchProductExistLocal();
        wishlistContent();
        await this.enableShareWishlist();
        this.clickEvents();
    };
    removeWishlistProductFromUI = (productId, handle) => {
        if (!productId && !handle || !isWishlistLandingLayout())
            return !1;
        let emptyWishlist = window.wishlistMetafields?.language2?.empty_wishlist || "Your wishlist is empty"
            , removed = !1;
        document.querySelectorAll(".tt-wishlist-landing-page-main .tt-product-list").forEach(productEl => {
            let matches = productId && String(productEl.getAttribute("data-id")) === String(productId) || handle && productEl.getAttribute("data-handle") === handle;
            if (!matches)
                return;
            let tab = productEl.closest(".tab-content-inner-wrap");
            productEl.remove();
            removed = !0;
            tab && !tab.querySelector(".tt-product-list") && (tab.innerHTML = `<p style="text-align:center;">${emptyWishlist}</p>`)
        }
        );
        if (removed) {
            let count = document.querySelectorAll(".tt-wishlist-landing-page-main .tt-product-list").length;
            wishlistUpdateCount(count);
            typeof window.wishlistUpdateHeaderCount === "function" && window.wishlistUpdateHeaderCount()
        }
        return removed
    }
        ;
    shouldRefreshWishlistContentAfterRemove = () => {
        return !isWishlistLandingLayout() || document.querySelectorAll(".tt-wishlist-landing-page-main .tt-product-list").length === 0
    }
        ;
    deleteProduct = async (id, handle) => {
        if (!id)
            return;
        (await removeProductApi(id)).status == 200 && (this.removeWishlistProductFromUI(id, handle),
            await this.getCategoryAllData(),
            typeof window.wishlistUpdateHeaderCount === "function" && window.wishlistUpdateHeaderCount(),
            this.shouldRefreshWishlistContentAfterRemove() && wishlistContent())
    }
        ;
    deleteProductLocal = async (id, handle) => {
        //guest delete
        let productsData = techno_getCookie("wishlist");
        let categoryData = techno_getCookie("wishlist_category");
        if (!productsData)
            return;
        try {
            productsData = JSON.parse(productsData);
        } catch (error) {
            console.error("Error parsing wishlist cookie:", error);
            return;
        }
        if (!Array.isArray(productsData))
            return;
        let newProductData = productsData.filter(item => {
                let flag = !0;
                return item.p_id == id && (flag = !1),
                    flag
            }
            );
        newProductData = JSON.stringify(newProductData),
            techno_setCookie("wishlist", "", 0),
            techno_setCookie("wishlist", newProductData, 100);
        let parsedCategory = [];
        if (categoryData) {
            try {
                parsedCategory = JSON.parse(categoryData);
            } catch (error) {
                console.error("Error parsing wishlist_category cookie:", error);
            }
        }
        techno_getCookie("techno_guest_user_id") && parsedCategory[0]?.category_id && await removeProductApi(id, true, parsedCategory[0]?.category_id),
            this.removeWishlistProductFromUI(id, handle),
            this.fetchProductExistLocal(),
            typeof window.wishlistUpdateHeaderCount === "function" && window.wishlistUpdateHeaderCount(),
            this.shouldRefreshWishlistContentAfterRemove() && wishlistContent(),
            await this.enableShareWishlist()
    }
        ;
    setButtons = () => {
        if (!this.wishlistMeta)
            return !1;
        const isSharedView = window.isWishlistSharedPage;
        if (!isSharedView) {
            let allPlaceParent = document.querySelectorAll(".wishlist-pdp-btn-main")
                , button_style = this.wishlistMeta.button_style || {}
                , buttonSty = button_style.btnStyle
                , buttonStyleClass = getMainButtonClass(buttonSty)
                , buttonText = button_style.btnText
                , buttonAfterText = button_style.btnTextAfterWishlist
                , buttonColor = button_style.btnColor
                , buttonBg = button_style.btnBgColor
                , buttonAfterColor = button_style.btnColorAfterWishlist
                , buttonAfterBg = button_style.btnBgColorAfterWishlist
                , voteBtnMeta = this.wishlistMeta.vote_btn || {};
            allPlaceParent.forEach(ele => {
                ele.classList.add(buttonStyleClass),
                    ele.setAttribute("style", `--tt-main-btn-color:${buttonColor}; --tt-main-btn-bg:${buttonBg}; --tt-main-af-btn-color:${buttonAfterColor}; --tt-main-af-btn-bg:${buttonAfterBg};`);
                if (ele.querySelector('.wishlist-pdp-btn-wrap')) return;
                let islikeButton = !1
                    , voteBtn = "";
                this.customerExist && (voteBtnMeta.enable == 1 || voteBtnMeta.enable) && (islikeButton = !0,
                    voteBtn = `
                    <button type="button" class="tt-vote-btn-wrap">
                        <span class="tt-vote-btn-span tt-vote-init-label">
                            <span class="tt-vote-icon">
                                ${wishlistLikeEmptyIcon}
                            </span>
                            <span class="tt-vote-count">0</span>
                        </span>
                        <span class="tt-vote-btn-span tt-vote-after-label">
                            <span class="tt-vote-icon">
                                ${wishlistLikeFillIcon}
                            </span>
                            <span class="tt-vote-count">0</span>
                        </span>
                    </button>
                `);
                let buttonHtml = `
                <div class="wishlist-pdp-btn-main-wrap">
                    <button type="button" class="wishlist-pdp-btn-wrap ${islikeButton ? "" : "full-width"}">
                        <span class="wishlist-btn-content-span wishlist-init-label">
                            <span class="wishlist-icon">
                                ${wishlistEmptyIcon}
                            </span>
                            <span class="tt-btn-text">${buttonText}</span>
                        </span>
                        <span class="wishlist-btn-content-span wishlist-after-label">
                            <span class="wishlist-icon">
                                ${wishlistFillIcon}
                            </span>
                            <span class="tt-btn-text">${buttonAfterText}</span>
                        </span>
                    </button>
                    ${voteBtn}
                </div>
            `;
                ele.innerHTML = buttonHtml
            }
            );
            if (this.wishlistMeta.button_setting?.launch_btn_type == "floating_btn" && !document.querySelector(".wishlist-floating-btn-main")) {
                let floatingButton = document.createElement("DIV")
                    , buttonClass2 = this.wishlistMeta.button_setting.launch_btn_placement
                    , buttonStyle = this.wishlistMeta.button_setting.launch_btn_style
                    , buttonRadius = this.wishlistMeta.button_setting.launch_btn_radius
                    , buttonColor2 = this.wishlistMeta.button_setting.launch_btn_text_color
                    , buttonBg2 = this.wishlistMeta.button_setting.launch_btn_bg_color
                    , buttonText2 = this.wishlistMeta.button_setting.launch_btn_text;
                floatingButton.setAttribute("class", `wishlist-floating-btn-main ${buttonClass2} ${buttonStyle} ${buttonRadius}`),
                    floatingButton.setAttribute("style", `--floating-btn-color:${buttonColor2}; --floating-btn-bg:${buttonBg2}`);
                let buttonHtml = `
                <button type="button" class="wishlist-floting-btn-wrap">
                    <span class="wishlist-icon">
                        ${wishlistEmptyIcon}
                    </span>
                    <span class="wishlist-btn-text">${buttonText2}</span>
                </button>
                `;
                floatingButton.innerHTML = buttonHtml,
                    document.body.append(floatingButton)
            } else if (this.wishlistMeta.button_setting?.launch_btn_type == "header_icon") {
                injectHeaderIcon();
            }
            this.customerExist && (this.wishlistMeta.vote_btn?.enable == 1 || this.wishlistMeta.vote_btn?.enable) && this.setupVoteBtn();
        }
        let plpBtnWrap = document.querySelectorAll(".tt-wishlist-plp-btn-main")
            , collectionStyle = (window.wishlistMetafields && window.wishlistMetafields.collection) || this.wishlistMeta.collection || {}
            , buttonClass = collectionStyle.icon_position
            , plpButtonColor = collectionStyle.icon_before_wishlist_color
            , plpButtonBg = collectionStyle.icon_after_wishlist_color;
        plpBtnWrap.forEach(ele => {
            if (this.wishlistMeta.save_for_later == 0 && ele.classList.contains("tt-cart-btn"))
                return !1;
            let url = window.location.href;
            if (url.indexOf('ladyblacktie') > -1) {
                plpButtonColor = '#000000';
                plpButtonBg = '#000000';
            } else {
                if (plpButtonColor == '#000000' && plpButtonBg == '#000000' || plpButtonColor == '#000' && plpButtonBg == '#000') {
                    plpButtonColor = '#ffffff';
                }
            }
            ele.setAttribute("style", `--wishlist-plp-btn-color:${plpButtonColor}; --wishlist-plp-btn-bg:${plpButtonBg}`),
                ele.classList.add("tt-position", buttonClass);
            // M3: Skip rewrite when PLP button markup already exists
            if (ele.querySelector('.wishlist-plp-btn-wrap')) return;
            let buttonHtml = `
                <button class="wishlist-plp-btn-wrap" type="button">
                    <span class="wishlist-btn-content-span wishlist-init-label">
                        ${wishlistEmptyIcon}
                    </span>
                    <span class="wishlist-btn-content-span wishlist-after-label">
                        ${wishlistFillIcon}
                    </span>
                </button>
            `;
            this.wishlistMeta.save_for_later == 1 && ele.classList.contains("tt-cart-btn") && (buttonHtml = `
                <button class="wishlist-plp-btn-wrap" type="button">
                    <span class="wishlist-btn-content-span wishlist-init-label">
                        Save for later
                    </span>
                    <span class="wishlist-btn-content-span wishlist-after-label">
                        Save for later
                    </span>
                </button>
            `),
                ele.innerHTML = buttonHtml
        }
        )
    }
        ;
    createCategory = async () => {
        let getCategories = null
            , currentCategoryHtml = "";
        try {
            getCategories = await getCategoriesApi();
            getCategories && getCategories.data && getCategories.data.length > 0 && getCategories.data.forEach(ele => {
                currentCategoryHtml += `
                    <div class="tt-form-group">
                        <span class="wishlist-p-tag">${ele.category_name}</span>
                        <button type="button" class="tt-btn tt-add-wishlist" cat-id="${ele.category_id}">Add</button>
                    </div>
                `
            });
        } catch (error) {
            console.error('[Super Wishlist] createCategory API failed:', error);
        }
        let categoryHtml = `
            <div class="wishlist-create-category-popup">
                <div class="tt-popup-overlay"></div>
                <div class="tt-category-popup">
                    <div class="tt-category-close">${wishlistPopupCloseIcon}</div>
                    <div class="tt-popup-content">
                        <div class="tt-wishlist-form">
                            <div class="tt-form-title">
                                    <p class="wishlist-p-tag">Add this item to a category</p>
                            </div>
                            <div class="tt-cat-wrap">
                                ${currentCategoryHtml}
                            </div>
                            <div class="tt-form-new-group">
                                <input type="text" name="wishlistname" placeholder="Create New Category">
                                <button type="button" class="tt-btn tt-add-wishlist">Create Category</button>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        `
            , divEle = document.createElement("DIV");
        divEle.setAttribute("class", "wishlist-create-category-popup-main"),
            document.querySelector(".wishlist-create-category-popup-main") ? document.querySelector(".wishlist-create-category-popup-main").innerHTML = categoryHtml : (divEle.innerHTML = categoryHtml,
                document.body.append(divEle)),
            this.clickEvents(),
            getCategories && this.getCategoryAllData(getCategories)
    }
        ;
    setupVoteBtn = async () => {
        let wishlistMainBtn = document.querySelectorAll(".wishlist-pdp-btn-main");
        if (wishlistMainBtn.length > 0) {
            let pId = wishlistMainBtn[0].getAttribute("data-pid")
                , voteCustomerData = await getCustomerVoteDataApi(pId);
            if (voteCustomerData.status == 200) {
                let voteBtnStyle = this.wishlistMeta.vote_btn
                    , buttonColor = voteBtnStyle.btn_color
                    , buttonBg = voteBtnStyle.btn_bg
                    , buttonAfterColor = voteBtnStyle.after_btn_color
                    , buttonAfterBg = voteBtnStyle.after_btn_bg;
                wishlistMainBtn.forEach(ele => {
                    let voteBtn = ele.querySelector(".tt-vote-btn-wrap");
                    voteBtn.setAttribute("style", `--tt-vote-btn-color:${buttonColor}; --tt-vote-btn-bg:${buttonBg}; --tt-vote-af-btn-color:${buttonAfterColor}; --tt-vote-af-btn-bg:${buttonAfterBg};`),
                        voteBtn.querySelectorAll(".tt-vote-count").forEach(innerEle => {
                            innerEle.innerHTML = voteCustomerData.data
                        }
                        ),
                        voteCustomerData.customerVote == 1 ? voteBtn.classList.add("active") : voteBtn.classList.remove("active")
                }
                )
            }
        }
    }
        ;
    syncGuestCustomerState = (customerId) => {
        // Never overwrite a real Shopify logged-in identity with guest state.
        if (window.isShopifyLoggedIn === !0) {
            restoreShopifyCustomerId();
            const shopifyId = String(window.shopifyCustomerId || window.customerId || "").trim();
            if (shopifyId && !shopifyId.startsWith("GUEST-")) {
                window.customerId = shopifyId;
                this.customerId = shopifyId;
                window.customerExist = !0;
                this.customerExist = !0;
            }
            return;
        }
        const id = customerId || getShareCustomerId();
        if (!id)
            return;
        window.customerId = id;
        this.customerId = id;
        // Guests keep customerExist=false so PDP/PLP clicks use guest cookie path.
        if (!String(id).startsWith("GUEST-")) {
            window.customerExist = !0;
            this.customerExist = !0;
        }
    }
        ;
    persistGuestCategoryId = categoryId => {
        categoryId && techno_setCookie("wishlist_category", JSON.stringify([{
            category_id: categoryId
        }]), 100)
    }
        ;
    resolveGuestCategoryIdFromServer = async (customerId, categoryName = "Guest Category") => {
        if (!customerId)
            return "";
        try {
            let response = await fetch(window.wishlistUrl + `get/product-details?customer_id=${encodeURIComponent(customerId)}`, {
                method: "GET",
                headers: {
                    shop: window.shop_domin
                }
            });
            if (!response.ok)
                return "";
            let data = await response.json();
            if (data.status != 200 || !Array.isArray(data.data))
                return "";
            let category = data.data.find(item => item.category_name === categoryName) || data.data[0];
            return category?.category_id ? String(category.category_id) : ""
        } catch (error) {
            console.error("[Wishlist] Failed to resolve guest category id:", error);
            return ""
        }
    }
        ;
    getGuestWishlistServerCount = async guestCustomerId => {
        if (!guestCustomerId)
            return 0;
        try {
            let response = await fetch(window.wishlistUrl + `get/product-details?customer_id=${encodeURIComponent(guestCustomerId)}`, {
                method: "GET",
                headers: {
                    shop: window.shop_domin
                }
            });
            if (!response.ok)
                return 0;
            let data = await response.json();
            if (data.status != 200 || !Array.isArray(data.data))
                return 0;
            return data.data.reduce((count, category) => count + (category.details?.length || 0), 0)
        } catch (error) {
            console.error("[Wishlist] Failed to read guest wishlist from server:", error);
            return 0
        }
    }
        ;
    activateGuestCustomerForShare = async guestCustomerId => {
        if (!guestCustomerId)
            return !1;
        try {
            let response = await fetch(window.wishlistUrl + "create-guest-user?customer_id=" + encodeURIComponent(guestCustomerId), {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                }
            })
                , data = await response.json()
                , activeId = data.customer_id || data.data?.customer_id || guestCustomerId;
            if (data.status == 200 && activeId) {
                techno_setCookie("techno_guest_user_id", activeId, 100);
                this.syncGuestCustomerState(activeId);
                return !0
            }
            console.warn("[Wishlist] Guest activate response:", data);
            return !!getGuestCustomerId()
        } catch (error) {
            console.error("[Wishlist] Guest activate failed:", error);
            return !1
        }
    }
        ;
    syncGuestWishlistToServer = async () => {
        let result = {
            ok: !1,
            syncedCount: 0,
            serverCount: 0
        }
            , customerId = getGuestCustomerId();
        if (!customerId || !hasLocalWishlistItems())
            return result;
        let productsData = []
            , guest_category_id;
        try {
            productsData = JSON.parse(techno_getCookie("wishlist") || "[]");
            let categoryData = techno_getCookie("wishlist_category");
            categoryData && (guest_category_id = JSON.parse(categoryData)[0]?.category_id)
        } catch (error) {
            console.error("Error preparing guest wishlist sync:", error);
            return result
        }
        if (!Array.isArray(productsData) || productsData.length === 0)
            return result;
        guest_category_id || (guest_category_id = "CAT-" + Math.floor(Math.random() * 1e5));
        this.syncGuestCustomerState(customerId);
        try {
            let catResponse = await createCategoryApi("Guest Category", guest_category_id, !0);
            if (!catResponse || catResponse.status != 200) {
                console.warn("[Wishlist] Guest category sync failed:", catResponse);
                result.serverCount = await this.getGuestWishlistServerCount(customerId);
                result.ok = result.serverCount > 0;
                return result
            }
            if (catResponse.data?.customer_id) {
                customerId = catResponse.data.customer_id;
                techno_setCookie("techno_guest_user_id", customerId, 100);
                this.syncGuestCustomerState(customerId)
            }
            guest_category_id = catResponse.data?.category_id || catResponse.data?.id || catResponse.category_id || await this.resolveGuestCategoryIdFromServer(customerId) || guest_category_id;
            if (!guest_category_id) {
                console.warn("[Wishlist] Guest category id missing after create-update.", catResponse);
                result.serverCount = await this.getGuestWishlistServerCount(customerId);
                result.ok = result.serverCount > 0;
                return result
            }
            this.persistGuestCategoryId(guest_category_id);
            for (const item of productsData) {
                if (!item?.p_id)
                    continue;
                try {
                    let addResponse = await addProductInCategoryApi(guest_category_id, item.p_id, !0);
                    (addResponse?.status == 200 || addResponse?.status == "200") && result.syncedCount++
                } catch (_) { }
            }
            result.serverCount = await this.getGuestWishlistServerCount(customerId);
            result.ok = result.serverCount > 0 || result.syncedCount > 0;
            result.ok || console.warn("[Wishlist] Guest wishlist sync finished with zero server items.", result)
        } catch (error) {
            console.error("[Wishlist] Guest wishlist sync failed:", error)
        }
        return result
    }
        ;
    prepareShareWishlist = async () => {
        if (!canShowShareWishlist())
            return !1;
        if (isLoggedInWishlistCustomer()) {
            const customerId = getShareCustomerId();
            if (!customerId)
                return !1;
            this.syncGuestCustomerState(customerId);
            let serverCount = await this.getGuestWishlistServerCount(customerId);
            if (serverCount < 1) {
                console.warn("[Wishlist] Logged-in share has no server items.", customerId);
                return !1
            }
            this.updateShareUrls();
            return !0
        }
        if (!hasLocalWishlistItems())
            return !1;
        let guestId = await this.ensureGuestCustomer();
        if (!guestId)
            return !1;
        if (!await this.activateGuestCustomerForShare(guestId))
            return !1;
        guestId = getGuestCustomerId() || guestId;
        let syncResult = await this.syncGuestWishlistToServer();
        if (!syncResult.ok) {
            console.warn("[Wishlist] Share sync failed:", syncResult);
            return !1
        }
        this.updateShareUrls();
        return !0
    }
        ;
    enableShareWishlist = async () => {
        let shareButton = document.querySelector(".tt-wishlist-share-btn")
            , shareData = window.wishlistMetafields.share_wishlist_data
            , sharePopup = document.querySelector(".tt-share-wishlist-popup");
        if (!shareButton || !sharePopup)
            return;
        if (!canShowShareWishlist()) {
            shareButton.classList.add("tt-hide");
            return
        }
        shareButton.classList.remove("tt-hide");
        document.body.contains(sharePopup) || document.body.append(sharePopup);
        applySharePopupOptions(sharePopup, shareData);
        isLoggedInWishlistCustomer() && getShareCustomerId() && this.updateShareUrls()
    }
        ;
    applySharedWishlistPageLayout = (pageRoot, pageTitleEl) => {
        if (!pageRoot)
            return;
        pageRoot.classList.add("tt-wishlist-landing-page-main", "tt-wishlist-landing-active", "tt-wishlist-shared-view");
        document.body.classList.add("tt-wishlist-shared-page-active");
        document.querySelectorAll(".tt-wishlist-share-btn").forEach(el => {
            el.classList.add("tt-hide")
        });
        hideWishlistAppProxyNoise(pageRoot);
        if (pageTitleEl) {
            let sharedTitle = window.wishlistMetafields?.language2?.share_page_title || window.wishlistMetafields?.language2?.shared_wishlist_title || "Shared Wishlist";
            pageTitleEl.textContent = sharedTitle
        }
    }
        ;
    settingsBasedContent = () => {
        if (isWishlistAppProxyPage()) {
            applyWishlistSharePageSession();
            let pageTitle = window.wishlistMetafields.language2.page_title
                , pageTitleEl = document.querySelector(".tt-details-title p")
                , isEle = window.isWishlistSharedPage ? document.querySelector(window.wishlistSharedPageSelector) : document.querySelector(window.wishlistPageSelector);
            isEle = isEle || mountWishlistPageShell();
            window.isWishlistSharedPage && isEle ? this.applySharedWishlistPageLayout(isEle, pageTitleEl) : pageTitle && pageTitleEl && (pageTitleEl.innerHTML = pageTitle);
            if (isEle) {
                pageCountApi();
                mountWishlistPageShell();
                isEle.classList.add("tt-wishlist-landing-active");
                hideWishlistAppProxyNoise(isEle)
            }
            if (window.isWishlistSharedPage)
                return !1;
        }
        this.enableShareWishlist();
    }
        ;
    trendingWishlistSetup = async () => {
        let selector = document.querySelectorAll(".super-wishlist-trending-widget");
        if (selector.length == 0)
            return !1;
        let trendingData = await trendingApi();
        if (trendingData.status == 200 && trendingData.data && trendingData.data.length > 0) {
            let trendingSettings = this.wishlistMeta.trending
                , trending_layout = trendingSettings.trending_layout
                , trending_title = trendingSettings.trending_title
                , trending_desktop_per_row = trendingSettings.trending_desktop_per_row
                , trending_mobile_per_row = trendingSettings.trending_mobile_per_row
                , trending_slider_arrows = trendingSettings.trending_slider_arrows
                , trending_slider_auto_rotate = trendingSettings.trending_slider_auto_rotate
                , productsHtml = "";
            trendingData.data.forEach(ele => {
                productsHtml += `
                    <div class="tt-product-list swiper-slide" data-handle="${ele.handle}">
                    </div>
                `
            }
            );
            let trendingHtml = `
                <div class="tt-container">
                    <div class="tt-wishlist-trending-wrap">
                        <div class="tt-trending-title-wrap">
                            <p>${trending_title}</p>
                        </div>
                        <div class="tt-wishlist-trending-inner-wrap swiper">
                            <div class="swiper-wrapper">
                                ${productsHtml}
                            </div>
                            <div class="swiper-button swiper-button-next">
                            </div>
                            <div class="swiper-button swiper-button-prev">
                            </div>
                        </div>
                    </div>
                </div>
            `;
            selector.forEach(ele => {
                ele.classList.add(trending_layout),
                    ele.setAttribute("data-desktop-row", trending_desktop_per_row),
                    ele.setAttribute("data-mobile-row", trending_mobile_per_row),
                    ele.setAttribute("data-arrow", trending_slider_arrows),
                    ele.setAttribute("data-auto-rotate", trending_slider_auto_rotate),
                    trending_layout == "slider" ? ele.setAttribute("style", "--tt-wishlist-font-multipler:1;opacity:0") : ele.setAttribute("style", "--tt-wishlist-font-multipler:1"),
                    ele.innerHTML = trendingHtml
            }
            ),
                trending_layout == "slider" ? updateProductContent(!0, !0) : updateProductContent(!1, !0)
        }
    }
        ;
    // Guest restore on load: cookie state only — no guest API until Share is clicked.
    setGuest = async () => {
        if (!isTruthySetting(window.wishlistMetafields?.guest_wishlist))
            return;
        if (window.isShopifyLoggedIn || window.location.pathname.includes("wishlist-share"))
            return;
        const guestCustomerId = techno_getCookie("techno_guest_user_id");
        guestCustomerId && this.syncGuestCustomerState(guestCustomerId)
    };

    // Validate if a guest customer has any wishlist items
    validateGuestCustomerWishlist = async (guestCustomerId) => {
        try {
            // Check local wishlist cookie first
            const wishlistData = techno_getCookie("wishlist");
            if (wishlistData) {
                try {
                    const products = JSON.parse(wishlistData);
                    if (products && products.length > 0) {
                        return true; // Has local wishlist items
                    }
                } catch (error) {
                    console.error("Error parsing wishlist cookie:", error);
                }
            }

            // Check API for wishlist items
            const response = await fetch(window.wishlistUrl + `get/product-details?customer_id=${guestCustomerId}`, {
                method: "GET",
                headers: {
                    shop: window.shop_domin
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.status == 200 && data.data && data.data.length > 0) {
                    // Check if any category has products
                    for (const category of data.data) {
                        if (category.details && category.details.length > 0) {
                            return true; // Has API wishlist items
                        }
                    }
                }
            }

            return false; // No wishlist items found
        } catch (error) {
            console.error("Error validating guest customer wishlist:", error);
            return false; // Assume no items on error
        }
    };

    // Clean up invalid guest customer data (no wishlist items)
    cleanupInvalidGuestCustomer = async (guestCustomerId) => {
        try {
            // Call API to delete the guest customer
            const deleteResponse = await fetch(window.wishlistUrl + "delete-guest-user", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                },
                body: JSON.stringify({
                    customer_id: guestCustomerId
                })
            });

            const deleteResult = await deleteResponse.json();

            if (deleteResult.status == 200) {

            } else {
                console.warn("Failed to cleanup invalid guest customer:", deleteResult);
            }
        } catch (error) {
            console.error("Error cleaning up invalid guest customer:", error);
        }

        // Always clean up local state and cookies
        this.resetGuestCustomerState();
    };

    ensureGuestCustomer = async () => {
        const existingId = techno_getCookie("techno_guest_user_id");
        if (existingId) {
            this.syncGuestCustomerState(existingId);
            return existingId;
        }
        const createdId = await this.createGuestCustomer();
        createdId && this.syncGuestCustomerState(createdId);
        return createdId;
    }
        ;

    // Create a new guest customer on-demand when they add their first wishlist item
    createGuestCustomer = async () => {
        try {
            const guestCreate = await fetch(window.wishlistUrl + "create-guest-user", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    shop: window.shop_domin
                }
            });

            const guestCreateDate = await guestCreate.json()
                , guestId = guestCreateDate.customer_id || guestCreateDate.data?.customer_id;

            if (guestCreateDate.status == 200 && guestId) {
                techno_setCookie("techno_guest_user_id", guestId, 100);
                this.syncGuestCustomerState(guestId);
                return guestId;
            } else {
                console.error("Failed to create guest customer:", guestCreateDate);
                return null;
            }
        } catch (error) {
            console.error("Error creating guest customer:", error);
            return null;
        }
    };

    // Reset guest customer state and cookies
    resetGuestCustomerState = () => {
        // Clear cookies
        techno_setCookie("techno_guest_user_id", "", 0);
        techno_setCookie("wishlist", "", 0);
        techno_setCookie("wishlist_category", "", 0);

        // Reset window variables
        window.customerExist = false;
        window.customerId = null;
    };

    updateShareUrls = () => {
        const customerId = getShareCustomerId();
        if (!customerId) {
            console.warn("[Wishlist] Share customer id is not available yet.");
            return;
        }
        window.customerId = customerId;

        document.querySelectorAll('.tt-share-wishlist a').forEach(link => {
            try {
                const url = new URL(link.href, window.location.origin);
                url.searchParams.set('q', customerId);
                link.href = url.toString();
            } catch (error) {
                console.error("Error updating share link:", error);
            }
        });

        const shareInput = document.getElementById('ttCopyShareUrlText');
        if (shareInput) {
            try {
                const url = new URL(shareInput.value, window.location.origin);
                url.searchParams.set('q', customerId);
                shareInput.value = url.toString();
            } catch (error) {
                shareInput.value = `${window.location.origin}/apps/wishlist/wishlist-share?q=${customerId}`;
            }
        }
    }


    init = () => {
        if (window.wishlistMetafields?.trending?.trending_layout == "slider") {
            this.loadSwiperAndInit();
        } else {
            this.initializeWishlist();
        }
    }

    loadSwiperAndInit = () => {
        // Check if Swiper is already loaded
        if (window.Swiper) {
            this.initializeWishlist();
            return;
        }

        // Load CSS
        let cssLink = document.createElement("link");
        cssLink.rel = "stylesheet";
        cssLink.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
        document.head.appendChild(cssLink);

        // Load JS with proper callback
        let jsScript = document.createElement("script");
        jsScript.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
        jsScript.onload = () => {
            this.initializeWishlist();
        };
        jsScript.onerror = () => {
            console.error('Failed to load Swiper script');
            this.initializeWishlist(); // Continue without Swiper
        };
        document.body.appendChild(jsScript);
    }

    initializeWishlist = () => {
        try {
            this.setButtons();
        } catch (error) {
            console.error('[Super Wishlist] setButtons failed during init:', error);
        }
        window.ttWishlistClickEvents = () => {
                this.clickEvents()
            }
            ;
        // Bind clicks immediately — do not wait on createCategory API (PDP race fix).
        this.clickEvents();
        if (isLoggedInWishlistCustomer())
            this.createCategory();
        else if (window.wishlistMetafields?.guest_wishlist == 1)
            this.fetchProductExistLocal();
        this.settingsBasedContent(),
            wishlistContent()
    }

    initializeSwiperSliders = () => {
        // Check if Swiper is available
        if (typeof Swiper === 'undefined') {
            console.warn('Swiper is not loaded, retrying in 100ms...');
            setTimeout(() => {
                this.initializeSwiperSliders();
            }, 500);
            return;
        }

        let allTrendingEle = document.querySelectorAll(".super-wishlist-trending-widget .swiper");
        if (allTrendingEle.length > 0) {
            let firstParent = allTrendingEle[0].closest(".super-wishlist-trending-widget")
                , slideDesk = Number(firstParent.getAttribute("data-desktop-row"))
                , slideMob = Number(firstParent.getAttribute("data-mobile-row"))
                , slideArrow = firstParent.getAttribute("data-arrow")
                , slideAuto = firstParent.getAttribute("data-auto-rotate")
                , sliderSettings = {
                    slidesPerView: slideMob,
                    loop: !1,
                    spaceBetween: 30,
                    breakpoints: {
                        300: {
                            slidesPerView: slideMob
                        },
                        991: {
                            slidesPerView: slideDesk
                        }
                    }
                };

            slideAuto && (sliderSettings.autoplay = {
                delay: 4e3
            });

            allTrendingEle.forEach((ele, index) => {
                try {
                    if (ele.classList.contains("swiper-initialized") || ele.swiper)
                        return;
                    let mainParent = ele.closest(".super-wishlist-trending-widget");
                    mainParent.style.opacity = 1;

                    if (slideArrow) {
                        sliderSettings.navigation = {
                            nextEl: ele.querySelector(".swiper-button-next"),
                            prevEl: ele.querySelector(".swiper-button-prev")
                        };
                    }

                    new Swiper(ele, sliderSettings);
                } catch (error) {
                    console.error(`Error initializing Swiper slider ${index + 1}:`, error);
                    // Fallback: show as grid
                    ele.style.display = 'grid';
                    ele.style.gridTemplateColumns = 'repeat(auto-fit, minmax(200px, 1fr))';
                    ele.style.gap = '1rem';
                }
            });
        }
    }
        ;
    syncInjectedWishlistButtons = () => {
        if (!this.wishlistMeta)
            return;
        try {
            this.setButtons();
        } catch (error) {
            console.error('[Super Wishlist] setButtons failed during button sync:', error);
        }
        if (isLoggedInWishlistCustomer())
            this.getCategoryAllData();
        else if (window.wishlistMetafields?.guest_wishlist == 1)
            this.fetchProductExistLocal();
    }
        ;
    reButtonsInit = (refreshContent = !0) => {
        if (!this.wishlistMeta) return;
        try {
            this.setButtons();
        } catch (error) {
            console.error('[Super Wishlist] setButtons failed during reinit:', error);
        }
        // Bind clicks immediately — createCategory is async enrichment only.
        this.clickEvents();
        if (isLoggedInWishlistCustomer())
            this.createCategory();
        else if (window.wishlistMetafields?.guest_wishlist == 1)
            this.fetchProductExistLocal();
        this.settingsBasedContent();
        refreshContent && wishlistContent();
    }
}
let wishlistData = new WishlistPDP;
window.wishlistInit = () => {
    window.whenSuperWishlistReady(() => wishlistData.init())
},
    window.wishlistButtonsInit = (refreshContent = !0) => {
        window.whenSuperWishlistReady(() => wishlistData.reButtonsInit(refreshContent))
    };

// â”€â”€â”€ Super Wishlist Header Web Component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Usage (manual): <super-wishlist-header></super-wishlist-header>
// Auto-injection: placed next to the cart icon in the header automatically.
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
class SuperWishlistHeader extends HTMLElement {
    constructor() {
        super();
        this._onWishlistUpdated = () => this.updateCount();
    }

    connectedCallback() {
        if (!this.hasAttribute("data-rendered")) {
            this.render();
            this.setAttribute("data-rendered", "true");
        }
        this.updateCount();
        document.removeEventListener("super-wishlist-updated", this._onWishlistUpdated);
        document.addEventListener("super-wishlist-updated", this._onWishlistUpdated);
    }

    disconnectedCallback() {
        document.removeEventListener("super-wishlist-updated", this._onWishlistUpdated);
    }

    render() {
        this.setAttribute('role', 'button');
        this.setAttribute('aria-label', 'Open Wishlist');
        this.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;cursor:pointer;position:relative;';

        this.innerHTML = `
            <button class="super-wishlist-header__btn" type="button" aria-label="Wishlist" style="
                all:unset;
                display:flex;
                align-items:center;
                justify-content:center;
                position:relative;
                cursor:pointer;
                height:44px;
                width:44px;
            ">
                <span class="super-wishlist-header__icon" style="display:flex;align-items:center;justify-content:center;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        style="transition:transform .15s ease;">
                        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                    </svg>
                </span>
                <span class="super-wishlist-header__count" style="
                    display:none;
                    align-items:center;
                    justify-content:center;
                    position:absolute;
                    top:-4px;
                    right:-6px;
                    background:#121212;
                    color:#fff;
                    border-radius:50%;
                    font-size:9px;
                    font-weight:600;
                    height:16px;
                    width:16px;
                    line-height:1;
                ">0</span>
            </button>`;

        this.querySelector('button').addEventListener('click', () => {
            if (typeof wishlistPopupOpen === 'function') {
                wishlistPopupOpen();
            } else {
                // Fallback: click the floating wishlist button if popup function not available
                document.querySelector('.wishlist-floting-btn-wrap')?.click();
            }
        });

        // Hover effect
        const btn = this.querySelector('button');
        const svg = this.querySelector('svg');
        btn.addEventListener('mouseenter', () => { if (svg) svg.style.transform = 'scale(1.1)'; });
        btn.addEventListener('mouseleave', () => { if (svg) svg.style.transform = 'scale(1)'; });
    }

    updateCount() {
        const countEl = this.querySelector('.super-wishlist-header__count');
        if (!countEl) return;

        // Try to get count from wishlist cookie (guest) or from window data (logged-in)
        let count = 0;

        try {
            const raw = techno_getCookie('wishlist');
            if (raw) {
                const items = JSON.parse(raw);
                if (Array.isArray(items)) count = items.length;
            }
        } catch (e) { /* ignore */ }

        // Also check server-loaded data if available
        if (window.getCategoriesData?.data) {
            let serverCount = 0;
            window.getCategoriesData.data.forEach(cat => {
                if (cat.details) serverCount += cat.details.length;
            });
            if (serverCount > count) count = serverCount;
        }

        countEl.textContent = count > 99 ? '99+' : count;
        countEl.style.display = count > 0 ? 'flex' : 'none';
    }
}

if (!customElements.get('super-wishlist-header')) {
    customElements.define('super-wishlist-header', SuperWishlistHeader);
}

// Expose a global helper so other parts of the code can trigger a count refresh
window.wishlistUpdateHeaderCount = () => {
    document.querySelectorAll('super-wishlist-header').forEach(el => {
        if (typeof el.updateCount === 'function') el.updateCount();
    });
    document.dispatchEvent(new CustomEvent('super-wishlist-updated'));
};

// â”€â”€â”€ Global click-redirect guard for ALL PLP wishlist buttons â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//
// Problem: Some Shopify themes wrap the ENTIRE product card in a single
// <a href="/products/..."> â€” clicking the heart icon bubbles to the anchor
// and navigates to the product page.
//
// Fix: Capture-phase listener calls preventDefault() ONLY (not stopPropagation)
// so the browser won't follow the anchor href, but the click event still
// bubbles normally to the wishlist handler in clickEvents().
//
//   âœ“ Auto-injected buttons  (placed by SuperWishlistCollectionInjector below)
//   âœ“ Liquid shortcode buttons (placed manually via theme template)
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
document.addEventListener('click', function (e) {
    const btn = e.target.closest('.tt-wishlist-plp-btn-main');
    if (!btn) return;

    // Only block navigation if the button sits inside a parent anchor
    let node = btn.parentElement;
    while (node && node !== document.body) {
        if (node.tagName === 'A' && node.href) {
            e.preventDefault(); // stops navigation ONLY, event keeps bubbling
            return;
        }
        node = node.parentElement;
    }
}, { capture: true });

// â”€â”€â”€ Super Wishlist Collection Auto-Injector â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//
// Mirrors xb-collection.js: scans the DOM for <a href*="/products/"> links,
// extracts the product handle, fetches the product ID via Shopify's product
// JSON endpoint, then injects a standard `.tt-wishlist-plp-btn-main` container
// onto each product card.
//
// Because we create the SAME element the existing code already looks for,
// ALL of the following work automatically â€” zero changes needed:
//   âœ“ setButtons()          â€” renders heart icon HTML
//   âœ“ getCategoryAllData()  â€” marks wishlisted buttons as active (logged-in)
//   âœ“ fetchProductExistLocal() â€” marks wishlisted buttons as active (guest)
//   âœ“ plpButtonClick()      â€” add/remove wishlist on click
//
// A MutationObserver watches for dynamically added product cards (infinite
// scroll, Quick-view callbacks, etc.) and re-runs the injector automatically.
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
(function SuperWishlistCollectionInjector() {
    const allowCollectionWishlistInjection = !window.location.pathname.includes('/blog');

    // â”€â”€ Helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    /** Extract the product handle from a /products/ URL. */
    function handleFromHref(href) {
        try {
            // href may be relative (/products/my-handle) or absolute
            const url = new URL(href, window.location.origin);
            const match = url.pathname.match(/\/products\/([^/?#]+)/);
            return match ? match[1] : null;
        } catch {
            return null;
        }
    }

    // â”€â”€ Known product-grid container selectors (covers all major Shopify themes) â”€
    const GRID_SELECTORS = [
        // Generic
        '.product-grid',
        '.products-grid',
        '.product-list',
        '.products',
        '.collection-grid',
        '[class*="product-grid"]',
        '[class*="products-grid"]',
        // Dawn / Shopify default
        '.collection__products',
        '.collection',
        // Debut
        '.product-grid-container',
        // Impulse / Expanse
        '.grid--collection',
        '.grid--uniform',
        // Prestige
        '[data-section-type="collection-template"]',
        '[data-section-type="featured-collection"]',
        // Turbo / Out of the Sandbox
        '.product-list--collection',
        // Brooklyn
        '.grid-products',
        // Minimal / Boundless
        '.product__listing',
        // Search results
        '.search-results',
        '.search__results',
        // Common generic fallbacks
        'ul[class*="product"]',
        'ul[class*="grid"]',
    ];

    // â”€â”€ Contexts that must NEVER receive a wishlist button â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
    const EXCLUDED_SELECTORS = [
        'nav',
        'header',
        '.site-header',
        '.site-nav',
        'footer',
        '.site-footer',
        '.breadcrumb',
        '.breadcrumbs',
        '[class*="breadcrumb"]',
        '.predictive-search',
        '.search-bar',
        '.search-popup',
        '.header-search',
        '.header__search',
        '.recently-viewed-title',   // title links, not cards
        '.tt-wishlist-details-main',
        '.wishlist-page-widget',
        'super-wishlist-header',
    ].join(', ');

    /**
     * Walk UP from the product link to find the card container.
     * Requires the found ancestor to contain an <img> â€” this filters out
     * text-only links (breadcrumbs, "View product" text links, etc.).
     */
    function findCardContainer(linkEl) {
        const compat = (typeof window.superWishlistCompatSelectors === 'function')
            ? window.superWishlistCompatSelectors() : {};
        const cardSelectors = [
            ...(compat.cards || []),
            '.product-card',
            '.product-card-wrapper',
            '.card-wrapper',
            '.card--product',
            '.product-item',
            '.grid__item',
            '.collection-product-card',
            '.ProductItem',
            '.product_card',
            '[data-product-id]',
            'li',
            'article',
        ];

        for (const sel of cardSelectors) {
            const ancestor = linkEl.closest(sel);
            // Must contain an image â€” otherwise it's not a product card
            if (ancestor && ancestor.querySelector('img')) return ancestor;
        }

        // Fallback: walk up 4 levels looking for any element with an img
        let node = linkEl.parentElement;
        for (let i = 0; i < 4 && node; i++) {
            if (node.querySelector('img')) return node;
            node = node.parentElement;
        }

        return null; // not a product card, skip
    }

    /** Determine where to place the wishlist button inside the card. */
    function findInsertionTarget(card) {
        // Most themes wrap the product image in one of these
        const compat = (typeof window.superWishlistCompatSelectors === 'function')
            ? window.superWishlistCompatSelectors() : {};
        const imageWrappers = [
            ...(compat.images || []),
            '.card__media',
            '.card-media',
            '.product-card__image-wrapper',
            '.product-card__img-wrapper',
            '.ProductItem__Image',
            '.product__media',
            '.aspect-ratio',
            'figure',
            '.media',
            '.image-wrapper',
        ];

        for (const sel of imageWrappers) {
            const el = card.querySelector(sel);
            if (el) return el;
        }

        // Fallback: first image container
        const img = card.querySelector('img');
        return img ? img.closest('a, div, figure') || img.parentElement : card;
    }

    // Cache: handle â†’ product id (avoids re-fetching on scroll / observer runs)
    const productIdCache = {};
    // Set of card DOM nodes already injected (avoids duplicates)
    const injectedCards = new WeakSet();

    /**
     * Fetch product ID for a given handle.
     * Returns null on failure.
     */
    async function fetchProductId(handle) {
        if (productIdCache[handle] !== undefined) return productIdCache[handle];

        try {
            const resp = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
                method: 'GET',
                headers: { 'Accept': 'application/json' }
            });

            if (!resp.ok) {
                productIdCache[handle] = null;
                return null;
            }

            const data = await resp.json();
            const id = data?.id ? String(data.id) : null;
            productIdCache[handle] = id;
            return id;
        } catch {
            productIdCache[handle] = null;
            return null;
        }
    }

    /**
     * Create and inject a .tt-wishlist-plp-btn-main element onto a card.
     * Placement uses findInsertionTarget (image/media wrapper) + position:relative
     * on that same node. Navigation is blocked by the global capture-phase guard.
     */
    function injectButton(card, productId, handle) {
        if (injectedCards.has(card)) return;
        if (card.querySelector('.tt-wishlist-plp-btn-main')) return; // already present via Liquid

        // Place on the image/media wrapper (same node that becomes position:relative)
        // so absolute PLP CSS anchors to the product image, not the card root.
        const target = findInsertionTarget(card) || card;
        if (!target) return;

        const targetStyle = window.getComputedStyle(target);
        if (targetStyle.position === 'static') {
            target.style.position = 'relative';
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'tt-wishlist-plp-btn-main super-wishlist-auto-injected';
        wrapper.setAttribute('data-pid', productId);
        wrapper.setAttribute('data-handle', handle);

        // Navigation is blocked by the global capture-phase guard above.
        target.appendChild(wrapper);

        injectedCards.add(card);
    }

    // â”€â”€ Main scanner â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    let scanScheduled = false;
    const pendingReinit = { timer: null };

    /**
     * Schedule a debounced call to wishlistButtonsInit() after all cards in the
     * current batch have been injected.  This triggers setButtons() +
     * getCategoryAllData() / fetchProductExistLocal() for the new buttons.
     */
    function scheduleReinit() {
        clearTimeout(pendingReinit.timer);
        pendingReinit.timer = setTimeout(() => {
            if (typeof window.wishlistButtonsInit === 'function') {
                window.wishlistButtonsInit(false);
            }
            // Also update header count badge
            if (typeof window.wishlistUpdateHeaderCount === 'function') {
                window.wishlistUpdateHeaderCount();
            }
        }, 80);
    }

    async function scanAndInject() {
        if (window.location.pathname.includes('/checkout') || !allowCollectionWishlistInjection) return;

        // â”€â”€ Step 1: Find product grid containers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
        // Collect every known grid container present on this page.
        const compat = (typeof window.superWishlistCompatSelectors === 'function')
            ? window.superWishlistCompatSelectors() : {};
        const gridEls = new Set();
        [...(compat.grid || []), ...GRID_SELECTORS].forEach(sel => {
            try { document.querySelectorAll(sel).forEach(el => gridEls.add(el)); } catch (_) {}
        });

        // If no known grid found, fall back to <main> so we still work on
        // custom / headless storefront layouts â€” but we still apply exclusions.
        if (gridEls.size === 0) {
            const main = document.querySelector(
                'main, [role="main"], #MainContent, .main-content, #main'
            );
            if (main) gridEls.add(main);
        }

        if (gridEls.size === 0) return; // nothing useful on this page

        // â”€â”€ Step 2: Collect product links ONLY inside grids â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
        // Also skip links that live in nav / header / footer / breadcrumb / search.
        const linkSet = new Set();
        gridEls.forEach(grid => {
            grid.querySelectorAll('a[href*="/products/"]').forEach(link => {
                // Skip if this link is inside an excluded context
                if (link.closest(EXCLUDED_SELECTORS)) return;
                linkSet.add(link);
            });
        });

        if (linkSet.size === 0) return;

        // â”€â”€ Step 3: Deduplicate by handle (one API fetch per product) â”€â”€â”€â”€â”€â”€â”€â”€â”€
        const handleToLinks = new Map();
        linkSet.forEach(link => {
            const handle = handleFromHref(link.href);
            if (!handle) return;
            if (!handleToLinks.has(handle)) handleToLinks.set(handle, []);
            handleToLinks.get(handle).push(link);
        });

        let anyNew = false;

        // â”€â”€ Step 4: Fetch product IDs + inject â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
        await Promise.all([...handleToLinks.entries()].map(async ([handle, links]) => {
            const productId = await fetchProductId(handle);
            if (!productId) return;

            links.forEach(link => {
                const card = findCardContainer(link);
                if (!card) return; // not a real product card (no img), skip

                // Extra safety: skip excluded contexts
                if (card.closest(EXCLUDED_SELECTORS)) return;

                if (!injectedCards.has(card) && !card.querySelector('.tt-wishlist-plp-btn-main')) {
                    injectButton(card, productId, handle);
                    anyNew = true;
                }
            });
        }));

        if (anyNew) {
            scheduleReinit();
        }
    }

    // â”€â”€ MutationObserver for dynamic content â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    const observer = new MutationObserver(() => {
        if (scanScheduled) return;
        scanScheduled = true;
        // Small delay to batch rapid DOM mutations (e.g. infinite-scroll dumps)
        setTimeout(() => {
            scanScheduled = false;
            scanAndInject();
        }, 200);
    });

    // â”€â”€ Initialise â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    function init() {
        // Run immediately on load
        scanAndInject();

        // Watch the whole body for added nodes (infinite scroll, AJAX filters, etc.)
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        // DOMContentLoaded already fired (script loaded async / deferred)
        init();
    }

    // Expose for manual triggering (e.g. after theme filter AJAX)
    window.superWishlistScanCollection = scanAndInject;

    // H2: Theme Editor / OS 2.0 section lifecycle
    const sectionRescan = () => {
        setTimeout(() => { scanAndInject(); }, 50);
    };
    document.addEventListener('shopify:section:load', sectionRescan);
    document.addEventListener('shopify:section:reorder', sectionRescan);

})();

// â”€â”€â”€ Super Wishlist PDP Auto-Injector â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
//
// Mirrors xb-wishlist-button-auto from xb-collection.js.
//
// On product pages: auto-detects the product ID + handle, finds the
// Add-to-Cart / Buy-button area (20+ theme selectors), and injects a
// standard `.wishlist-pdp-btn-main` element so ALL existing handlers
// wire up automatically â€” zero changes needed:
//
//   âœ“ setButtons()             â€” renders the heart icon button HTML
//   âœ“ getCategoryAllData()     â€” marks button active (logged-in user)
//   âœ“ fetchProductExistLocal() â€” marks button active (guest)
//   âœ“ pdpButtonClick()         â€” add / remove on click
//
// Placement tries these positions in order (first match wins):
//   1. After the Add-to-Cart button
//   2. Before the Add-to-Cart button
//   3. After the Buy-Now / payment buttons
//   4. After the product form
//   5. After the product title
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
(function SuperWishlistPDPInjector() {

    // â”€â”€ Is this a product page? â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    function isProductPage() {
        // Shopify sets this on every product page
        if (window.ShopifyAnalytics?.meta?.product) return true;
        // Liquid-rendered meta tag
        if (document.querySelector('meta[property="og:type"][content="product"]')) return true;
        // URL check
        if (/\/products\/[^/?#]+/.test(window.location.pathname)) return true;
        return false;
    }

    // â”€â”€ Read product data from every Shopify data source â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    async function getProductData() {
        // 1. ShopifyAnalytics (most reliable, set by Shopify on all product pages)
        const meta = window.ShopifyAnalytics?.meta?.product;
        if (meta?.id && meta?.handle) {
            return { id: String(meta.id), handle: meta.handle };
        }

        // 2. theme.js / window.theme product object (many themes set this)
        if (window.theme?.product?.id && window.theme?.product?.handle) {
            return { id: String(window.theme.product.id), handle: window.theme.product.handle };
        }

        // 3. window.product (some themes expose this directly)
        if (window.product?.id && window.product?.handle) {
            return { id: String(window.product.id), handle: window.product.handle };
        }

        // 4. Derive handle from URL and fetch via Shopify product JSON
        const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
        if (match) {
            const handle = match[1];
            try {
                const resp = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
                    headers: { Accept: 'application/json' }
                });
                if (resp.ok) {
                    const data = await resp.json();
                    if (data?.id) return { id: String(data.id), handle: data.handle || handle };
                }
            } catch { /* fall through */ }
        }

        return null; // couldn't determine product data
    }

    // â”€â”€ Selector banks â€” mirrors Dt.SelectorLocation from xb-collection.js â”€â”€â”€â”€â”€

    // BUY_BUTTONS: Dynamic checkout / Buy Now buttons (Shopify payment button)
    // xb default: wishlist goes BEFORE these = between ATC and Buy Now
    const BUY_BUTTON_SELECTORS = [
        '.shopify-payment-button',
        '[data-shopify="payment-button"]',
        '.product-form__payment-container',
        '.product__payment-button',
        '#dynamic-checkout-cart',
        '.dynamic-checkout__content',
    ];

    // ADD_TO_CART: The submit / ATC button itself or its immediate container
    const ATC_SELECTORS = [
        // Dawn / OS 2.0
        '.product-form__buttons',
        '.product-form__submit',
        // Debut
        '.product-form--payment-button-no-variants',
        // Expanse / Impulse
        '.product__submit',
        '.product-submit-section',
        // Brooklyn / Minimal
        '.product-single__add-to-cart',
        // Turbo
        '.product_form .product-add',
        // Generic
        'form[action="/cart/add"] button[type="submit"]',
        'form[action*="/cart/add"] button[type="submit"]',
        '[data-add-to-cart]',
        '[name="add"]',
        '.product-form button[type="submit"]',
    ];

    // PRODUCT_DESC: Product description / body area
    const DESC_SELECTORS = [
        '[class*="product_description"]',
        '.product__description',
        '.product-single__description',
        '.product-description',
        '.product__content .rte',
        '.product-block--description',
    ];

    // â”€â”€ Injection â€” mirrors xb-wishlist-button-auto logic exactly â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    let injected = false;

    function syncInjectedFlag() {
        // H1: Re-sync when theme AJAX removes / replaces the mount
        injected = !!document.querySelector('.wishlist-pdp-btn-main');
    }

    function injectPDPButton(productId, handle) {
        syncInjectedFlag();
        if (injected) return;
        // If already placed via Liquid shortcode, nothing to do
        if (document.querySelector('.wishlist-pdp-btn-main')) {
            injected = true;
            return;
        }

        // M4: Optional overrides from app metafields
        let autoSettings = window.wishlistMetafields?.pdp_auto_placement || {};
        if (typeof autoSettings === 'string') {
            try { autoSettings = JSON.parse(autoSettings); } catch { autoSettings = {}; }
        }
        const compat = (typeof window.superWishlistCompatSelectors === 'function')
            ? window.superWishlistCompatSelectors() : {};
        const selectorLocation = compat.pdpSelectorLocation || autoSettings.selectorLocation || 'ADD_TO_CART';
        const position = compat.pdpPosition || autoSettings.position || 'beforebegin';

        // Detect Shopify's special spacing-style button container (used by Dawn etc.)
        const spacingStyleBtns = document.querySelector('.product-form-buttons.spacing-style');

        let targetSel = null;
        let insertPos = position;

        // â”€â”€ Replicate xb's exact placement logic â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
        if (selectorLocation === 'ADD_TO_CART') {
            if (spacingStyleBtns) {
                // xb special case: when the spacing-style container exists
                if (position === 'beforebegin') {
                    // Insert BEFORE the whole button block
                    targetSel = '.product-form-buttons.spacing-style';
                    insertPos = 'beforebegin';
                } else {
                    // Insert BEFORE the Buy Now / payment buttons
                    // = between ATC button and Buy Now   â† xb default
                    targetSel = BUY_BUTTON_SELECTORS.find(s => document.querySelector(s)) || null;
                    insertPos = 'beforebegin';
                }
            } else {
                // No spacing-style container: try Buy Now first (between ATC and Buy Now)
                targetSel = BUY_BUTTON_SELECTORS.find(s => document.querySelector(s)) || null;
                if (targetSel) {
                    insertPos = 'beforebegin'; // before Buy Now = after ATC
                } else {
                    // No Buy Now buttons â€” fallback: after the ATC button/container
                    targetSel = ATC_SELECTORS.find(s => document.querySelector(s)) || null;
                    insertPos = 'afterend';
                }
            }
        } else if (selectorLocation === 'PRODUCT_DESC') {
            // After product description block
            if (spacingStyleBtns) {
                targetSel = '[class*="product_description"]';
            } else {
                targetSel = DESC_SELECTORS.find(s => document.querySelector(s)) || null;
            }
            insertPos = 'afterend';
        } else {
            // Custom selector from settings
            targetSel = selectorLocation;
            insertPos = position;
        }

        // Resolve the actual DOM element
        let targetEl = targetSel ? document.querySelector(targetSel) : null;

        // Ultimate fallback cascade if nothing matched
        if (!targetEl) {
            for (const sel of [...ATC_SELECTORS, ...DESC_SELECTORS]) {
                targetEl = document.querySelector(sel);
                if (targetEl) { insertPos = 'afterend'; break; }
            }
        }

        if (!targetEl) {
            console.warn('[Super Wishlist PDP] Could not find a placement target on this page.');
            return;
        }

        const wrapper = document.createElement('div');
        wrapper.className = 'wishlist-pdp-btn-main super-wishlist-pdp-auto';
        wrapper.setAttribute('data-pid', productId);
        wrapper.setAttribute('data-handle', handle);

        targetEl.insertAdjacentElement(insertPos, wrapper);

        injected = true;

        scheduleInit();
    }

    // â”€â”€ Debounced reinit â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    let initTimer = null;
    function scheduleInit() {
        clearTimeout(initTimer);
        initTimer = setTimeout(() => {
            if (typeof window.wishlistButtonsInit === 'function') {
                window.wishlistButtonsInit(false);
            }
        }, 80);
    }

    // â”€â”€ Cleanup on bfcache restore (back/forward navigation) â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    window.addEventListener('pageshow', (e) => {
        if (e.persisted) {
            // Page was restored from bfcache â€” remove auto-injected button
            // and reset flag so it can be re-injected cleanly
            document.querySelectorAll('.wishlist-pdp-btn-main.super-wishlist-pdp-auto')
                .forEach(el => el.remove());
            injected = false;
            // Re-run after a tick to let the page settle
            setTimeout(run, 100);
        }
    });

    // â”€â”€ Main entry â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€

    async function run() {
        if (!isProductPage()) return;
        syncInjectedFlag();
        if (injected) return;

        const data = await getProductData();
        if (!data) {
            console.warn('[Super Wishlist PDP] Could not read product data on this page.');
            return;
        }

        injectPDPButton(data.id, data.handle);
    }

    // H1: Watch for late ATC/form mounts and theme AJAX that removes the button
    let pdpScanScheduled = false;
    const pdpObserver = new MutationObserver(() => {
        if (!isProductPage()) return;
        if (pdpScanScheduled) return;
        pdpScanScheduled = true;
        setTimeout(() => {
            pdpScanScheduled = false;
            syncInjectedFlag();
            if (!injected) run();
        }, 200);
    });

    // Wait for DOM + wishlist app to be ready
    function init() {
        // Give the wishlist app a moment to set up window.wishlistButtonsInit
        setTimeout(run, 300);
        if (document.body) {
            pdpObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Expose for manual triggering (e.g. after a theme AJAX variant switch)
    window.superWishlistScanPDP = run;

    // H2: PDP section lifecycle (theme editor / section HTML swaps)
    document.addEventListener('shopify:section:load', () => {
        if (!isProductPage()) return;
        setTimeout(() => {
            syncInjectedFlag();
            if (!injected) run();
        }, 50);
    });

})();
